window.templates = {
  twitchChat: `<div data-component="twitch-chat"></div>`,

  openPack: `
    <div data-component="open-pack" class="always-display">
      <div class="open-pack-wrapper" v-bind:class="{ show: model.packLoaded }">
        <div class="open-pack-container collapsed">
          <h2 v-if="model.twitchDisplayName" :title="model.twitchDisplayName[0].twitchDisplayName">{{ model.twitchDisplayName[0].twitchDisplayName }}</h2>
          <div id="opened-cards" class="opened-cards-wrapper">
            <div class="opened-cards">
            <component
              v-for="card in model.userCards"
              :key="card.id"
              :is="card.tier >= 4 ? 'special-card' : 'playing-card'"
              :card="card"
              :show="'true'"
            ></component>
            </div>
          </div>
          <playing-card id="cover" class="cover pulse" :class="model.pack.name" v-bind:card="model.card" v-bind:show="'true'"></playing-card>
          </div>
        </div>
      </div>
    </div>
  `,

  showMedal: `
    <div data-component="show-medal" class="always-display">
      <div v-if="model.medal" v-bind:class="{ show: model.show }">
        <div>
          <h2 title="Achievement Unlocked">Achievement Unlocked</h2>
          <h3 :title="model.medal.name">{{ model.medal.name }}</h3>
        </div>
        <div class="video-container">
          <video :src="model.medal.src" class="video-overlay__video" loop muted autoplay playsinline></video>
        </div>
        <div>
          <!--<img :src="model.medal.twitchProfileImage">-->
          <h3 :title="model.medal.twitchDisplayName">{{ model.medal.twitchDisplayName }}</h3>
          <h4 :title="model.medal.description">{{ model.medal.description }}</h4>
        </div>
      </div>
    </div>
  `,

  showKey: `
    <div data-component="show-key" class="always-display">
      <div v-if="model.key" v-bind:class="{ show: model.show }">
        <div>
          <h2>Key Used</h2>
          <h3>{{ model.key.name }}</h3>
        </div>
        <div class="video-container">
          <video :src="model.key.src" :data-id="model.key.keyId" class="video-overlay__video" loop muted autoplay playsinline></video>
        </div>
        <div>
          <!--<img :src="model.key.twitchProfileImage">-->
          <h3>{{ model.key.twitchDisplayName }}</h3>
          <h4>{{ model.key.description }}</h4>
        </div>
      </div>
    </div>
  `,

  receivedKey: `
    <div data-component="received-key" class="always-display">
      <div v-if="model.key" v-bind:class="{ show: model.show }">
        <div>
          <h2>Key Received</h2>
          <h3>{{ model.key.name }}</h3>
        </div>
        <div class="video-container">
          <video :src="model.key.src" :data-id="model.key.keyId" class="video-overlay__video" loop muted autoplay playsinline></video>
        </div>
        <div>
          <!--<img :src="model.key.twitchProfileImage">-->
          <h3>{{ model.key.twitchDisplayName }}</h3>
          <h4>{{ model.key.description }}</h4>
        </div>
      </div>
    </div>
  `,

  receivedPack: `
    <div data-component="received-pack" class="always-display">
      <div v-if="model.pack" v-bind:class="{ show: model.show }">
        <div>
          <h2>Pack Received</h2>
          <h3>{{ model.pack.name }}</h3>
        </div>
        <div class="video-container">
          <img :src="model.pack.src" />
        </div>
        <div>
          <h3>{{ model.pack.twitchDisplayName }}</h3>
        </div>
      </div>
    </div>
  `,

  battleArena: `
    <div data-component="battle-arena" class="always-display">
      <!--<button v-on:click="stop()">stop battle</button>-->
      <div class="content">
      <!--<div class="stupid-log"></div>-->
        <div class="row info" v-bind:class="{ show: model.show.users, move: model.show.move }">
          <div class="col-5 user user1">
            <img :src="model.user1.twitchProfileImage">
            <img src="/images/name-frame-01.png">
            <div>
              <h2>{{ model.user1.twitchDisplayName }}</h2>
            </div>
          </div>
          <div class="col-2 vs">
            <h1 class="white">VS</h1>
          </div>
          <div class="col-5 user user2">
            <img :src="model.user2.twitchProfileImage">
            <img src="/images/name-frame-01.png">
            <div>
              <h2>{{ model.user2.twitchDisplayName }}</h2>
            </div>
          </div>
        </div>
        <div class="row cards" v-bind:class="{ show: model.show.cards }">
          <div class="col-4 cards-1">
            <playing-card v-bind:card="card" v-bind:show="'true'" v-for="card in model.cards1"></playing-card>
          </div>
          <div class="col-4">
            <div class="log" v-bind:class="{ show: model.show.logs }">
              <p v-for="log in model.logs" :title="log">{{ log }}</p>
            </div>
          </div>
          <div class="col-4 cards-2">
            <playing-card v-bind:card="card" v-bind:show="'true'" v-for="card in model.cards2"></playing-card>
          </div>
        </div>
      </div>
      <div class="winner" v-bind:class="{ show: model.show.winner }">
        <h2 class="white">The Winner Is:</h2>
        <div></div>
      </div>
      <div class="stolen-card" v-bind:class="{ show: model.show.stolenCard }">
        <h2 class="white">Card Stolen:</h2>
        <playing-card v-if="model.stolenCard" v-bind:card="model.stolenCard" v-bind:show="'true'"></playing-card>
      </div>
    </div>  
  `,


  teamBattleArena: `
    <div data-component="battle-arena" class="always-display">
      <!--<button v-on:click="stop()">stop battle</button>-->

     
        <div id="first_round" class="content show">
            <div class="show-players">
              <div class="section">
                <teamSections  v-bind:user="user" v-bind:show="model.show.cards" v-bind:showUsers="model.show.users" v-bind:team="1" v-for="user in model.team1"></teamSections>
              </div>
              <div class="section-center log" v-bind:class="{ show: model.show.logs }">
                      <p v-for="log in model.logs" :title="log">{{ log }}</p>
              </div>
              <div class="section" >
                <teamSections  v-bind:user="user" v-bind:show="model.show.cards" v-bind:showUsers="model.show.users" v-bind:team="2" v v-for="user in model.team2"></teamSections>
              </div>
            </div>
        </div>


        <div id="final_round" class="content" v-bind:class="{ show: model.finalBattle }">
            <div class="show-players">
              <div class="section">
                <div class="left-cards">
                    <div class="cards-1">
                      <playing-card v-bind:card="card" v-bind:show="'true'" v-for="card in model.cards1"></playing-card>
                    </div>
                </div>
                <div class="left">
                   <div class="col-img">
                    <userTeamProfile v-bind:team="team" v-for="team in model.team1winner"></userTeamProfile>
                  </div>
                </div>
              </div>
              <div class="section-center log" v-bind:class="{ show: model.show.logs }">
                      <p v-for="log in model.logs" :title="log">{{ log }}</p>
              </div>
              <div class="section" >
                <div class="right">
                  <div class="col-img">
                   <userTeamProfile v-bind:team="team" v-for="team in model.team2winner"></userTeamProfile>\
                  </div>
                </div>
                <div class="right-cards">
                  <div class="cards-2">
                    <playing-card v-bind:card="card" v-bind:show="'true'" v-for="card in model.cards2"></playing-card>
                  </div>
                </div>
                 
              </div>
            </div>
        </div>
         
        <div class="row profile_intro" v-bind:class="{ show: model.show.profile_intro }">  
           
            <div class="col  user1">
              <h1>Team 1</h1>
              <userTeamProfile v-bind:team="team" v-for="team in model.team1"></userTeamProfile>
            </div>
            <div class="col vs">
              <h1 class="white">VS</h1>
            </div>
            <div class="col user2">
            <h1>Team 2</h1>
              <userTeamProfile v-bind:team="team" v-for="team in model.team2"></userTeamProfile>
            </div>
      </div>
      
      <div class="winner" v-bind:class="{ show: model.show.winner }">
        <h2 class="white">The Winner Is:</h2>
        <div></div>
      </div>
      <div class="stolen-card" v-bind:class="{ show: model.show.stolenCard }">
        <h2 class="white">Card Stolen:</h2>
        <playing-card v-if="model.stolenCard" v-bind:card="model.stolenCard" v-bind:show="'true'"></playing-card>
      </div>
    </div>  
`,

teamSections: `
      <div data-component="teamSections" class="always-display row" :id="user.user[0].twitchId"  :data-id="user.user[0].twitchId">
        <div :class="[team == '1' ? 'ltr-container' : 'rtl-container' ]"">
            <div class="user " v-bind:class="{ show: showUsers }">
              <img :src="user.user[0].twitchProfileImage">
              <div>
                <h2>{{ user.user[0].twitchDisplayName }}</h2>
              </div>
            </div>
             <div class="cards" v-bind:class="{show}">
                <div :class="[team == '1' ? 'cards-1' : 'cards-2']">
                  <playing-card v-bind:card="card" v-bind:show="'true'" v-for="card in user.cards"></playing-card>
                </div>
              </div>
        < /div>
      </div>
`,

  userTeamProfile: `
  <div data-component="team-profile" class="user_img" :id="team.twitchId" :data-id="team.twitchId">
      <img src="/images/name-frame-01.png">
      <img :src="team.user[0].twitchProfileImage">
      <div>
        <h2>{{ team.user[0].twitchDisplayName }}</h2>
      </div>
  </div>
`,

playingCard: `
 <div data-component="playing-card" :key="card.id"  draggable="true"  @contextmenu.prevent="showContextMenu" @dragstart="onDragStart" @dragend="onDragEnd"  @drop="onDrop($event, card)" @dragover.prevent="onDragOver"  @dragleave="onDragLeave"  :id="card.id" :data-id="card.id" class="playing-card-container" :class="{ show: model.show, selected: card.selected }" :data-number="card.cardNumber" :data-cooldown="card.cooldown" :data-hidden="card.name == ''" :data-count="card.count" v-on:click="select(card)">
  <div class="playing-card-wrapper" v-bind:class="{ on_drop: model.isDragging }" >
    <div class="playing-card " v-bind:class="{ disabled: card.name == ''}" v-on:click="flip(card.id)"  >
    <!--<div class="playing-card">-->
      <div class="playing-card-face playing-card-backing"></div>
      <div v-if="card.name == ''" class="playing-card-face playing-card-front disabled" :data-tier="card.tier">
        <!--<i class="question bi-question-circle"></i>-->
      </div>
      <div v-if="card.name != ''" class="playing-card-face playing-card-front" :data-tier="card.tier" :style="{'background-image': 'url(' + card.image + ')'}">
        <div class="playing-card-front-frame">
      
          <i v-if="card.selected"  class="check bi-check-circle-fill"></i>
          <i  v-if="card.cardNumber" class="x-circle bi bi-x-circle-fill"></i>

          <div class="top">
            <p :title="card.name">{{ card.name }}</p>
            <p :title="card.type">{{ card.type }}</p>
            <span class="tooltip">
              {{ model.tooltipMessage }}
            </span>
          </div>

          <div v-if="model.timer" class="cooldown-timers">
            <span>  
              <p>Cooldown</p>
              <p>{{ card.cooldown }}</p>
            </span>
          </div>

          <div class="bottom is-hidden">
            <div class="ability" :title="'Ability: ' + card.ability" :data-description="card.description">Ability: {{ card.ability }}</div>
            <div class="stats">
              <p :title="'ATK ' + card.attack">ATK {{ card.attack }}</p>
              <p :title="'DEF ' + card.defence">DEF {{ card.defence }}</p>
              <p :title="'SPD ' + card.speed">SPD {{ card.speed }}</p>
              <p :title="'ACC ' + card.accuracy">ACC {{ card.accuracy }}</p>
              <p :title="'HP ' + card.hp">HP {{ card.hp }}</p>
            </div>
            
          </div>
          
          <div class="info is-visible">
            <p class="number" v-if="card.cardNumber" :title="'Battle Number: #' + card.cardNumber">Battle Number: #{{ card.cardNumber }}</p>
            <p class="count" v-if="card.cardNumber && card.count"  :title="'Own: ' + card.count">Own: {{card.count}}</p>
          </div>
        </div>
      </div>
    </div>
          
    <div v-if="model.menuVisible" :style="'top:' +model.menuY+ 'px', 'right' + model.menuX + 'px'"  class="context-menu">
      <div v-if="card.favorites == 0" @click="addFavorites"><i class="bi bi-star"></i> Add to favorites</div>
      <div v-else @click="removeFavorites"><i class="bi bi-x-circle"></i> Remove to favorites</div>
    </div>

    <div v-if="model.menuVisible" class="overlay" @click="closeContextMenu"></div>
  </div>

</div>
`,

userInventory: `
<div data-component="user-inventory" :key="inventory.id" :id="inventory.id" :data-id="inventory.id"  :data-number="inventory.id">
  <div class="grid-item inventory"  @drop="onDrop($event, inventory)" @dragover.prevent>
    <div class="tier-upgrade dump" @click="openDump" id="dump_button" v-if="Number(inventory.tier) <= Number(inventory.total_tier)">
        <div class="tooltip">Dump {{inventory.dumpCard}} {{inventory.sacrificeCard.split(',',1)[0]}} to upgrade {{inventory.name}} Tier {{ inventory.tier }}</div>
      {{model.dumpCardCount}}
    </div>
    
    <div class="row">
      <div>
        <div v-if="!model.timer" class="cooldown-timers">
          <h4 v-on:click="activate(inventory)" >{{ Number(inventory.tier) > 2 ?  inventory.name + ' Tier '+ (Number(inventory.tier) - 1): inventory.name }}</h4>
        </div>
        <div v-else>
            <span>  
              <p>Cooldown</p>
              <p>{{ model.timer }}</p>
            </span>
        </div>
    </div>
  </div>
  
</div>
`,

specialCard: `
 <div data-component="special-card" draggable="true" @dragend="onDragEnd" @dragstart="onDragStart" :key="card.id" :id="card.id" :data-id="card.id" class="playing-card-container" :class="{ show: model.show, selected: card.selected }" :data-number="card.cardNumber" :data-cooldown="card.cooldown" :data-hidden="card.name == ''" :data-count="card.count" v-on:click="select(card)">
  <div class="playing-card-wrapper">
    <div class="playing-card on_drop" v-on:click="flip(card.id)" v-bind:class="{ spinning: model.spinning === true }" >
    <!--<div class="playing-card">-->
      <div class="playing-card-face playing-card-backing"></div>
      <div v-if="card.name == ''" class="playing-card-face playing-card-front disabled" :data-tier="card.tier ? card.tier : '6'">
        <!--<i class="question bi-question-circle"></i>-->
      </div>
      <div v-if="card.name != ''" class="playing-card-face playing-card-front" :data-tier="card.tier" :style="{'background-image': 'url(' + card.image + ')'}">
        <div class="playing-card-front-frame">
      
          <i v-if="card.selected"  class="check bi-check-circle-fill"></i>
          <i  v-if="card.cardNumber" class="x-circle bi bi-x-circle-fill"></i>

          <div class="top">
            <p :title="card.name">{{ card.name }}</p>
            <p :title="card.type">{{ card.type }}</p>
            <span class="tooltip" >{{model.tooltipMessage}}</span>
          </div>

          <div class="bottom is-hidden">
            <div class="ability"> {{ card.description }}</div>
          </div>
          
          <div class="info is-visible">
            <p class="number" v-if="card.cardNumber" :title="'Battle Number: #' + card.cardNumber">Battle Number: #{{ card.cardNumber }}</p>
            <p class="count" v-if="card.cardNumber" :title="'Own: ' + card.count">Own: {{card.count}}</p>
          </div>
        </div>
      </div>
    </div>
          
    <div v-if="model.menuVisible" :style="'top:' +model.menuY+ 'px', 'right' + model.menuX + 'px'"  class="context-menu">
      <div v-if="card.favorites == 0" @click="addFavorites"><i class="bi bi-star"></i> Add to favorites</div>
      <div v-else @click="removeFavorites"><i class="bi bi-x-circle"></i> Remove to favorites</div>
    </div>

    <div v-if="model.menuVisible" class="overlay" @click="closeContextMenu"></div>
  </div>
</div>
`,
  navigation: `
    <div data-component="navigation" class="always-display">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'queues' }" v-on:click="click('queues')">Queues</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'leaderboard' }" v-on:click="click('leaderboard')">Leaderboard</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'cards' }" v-on:click="click('cards')">Cards</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'special' }" v-on:click="click('special')">Specialcards</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'bone-cards' }" v-on:click="click('bone-cards')">Bone Cards</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'packs' }" v-on:click="click('packs')">Packs</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'types' }" v-on:click="click('types')">Types</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'abilities' }" v-on:click="click('abilities')">Abilities</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'keys' }" v-on:click="click('keys')">Keys</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'medals' }" v-on:click="click('medals')">Achievements</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'Admin' }" v-on:click="click('Admin')">Admin</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'settings' }" v-on:click="click('settings')">Settings</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'store' }" v-on:click="click('store')">Store</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'quest' }" v-on:click="click('quest')">Quest</button>
        </li>
      </ul>
    </div>
  `,

  navigation2: `
    <div data-component="navigation" class="always-display light">
      <ul class="nav nav-pills justify-content-center">
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'cards' }" v-on:click="click('cards')"><i class="bi-collection-fill"></i> Cards</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'medals' }" v-on:click="click('medals')"><i class="bi bi-award-fill"></i> Achievements</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'keys' }" v-on:click="click('keys')"><i class="bi bi-key-fill"></i> Keys</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'tags' }" v-on:click="click('tags')"><i class="bi bi-tag-fill"></i> Dog Tags</button>
        </li>
      </ul>
       <ul class="nav nav-tabs justify-content-center">
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.cards == 'yours' }" v-on:click="cards('yours')">Your Cards</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.cards == 'normal' }" v-on:click="cards('normal')">Standard</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.cards == 'ultras' }" v-on:click="cards('ultras')">Ultras</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.cards == 'legendary' }" v-on:click="cards('legendary')">Legendary</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.cards == 'ultimates' }" v-on:click="cards('ultimates')">Ultimates</button>
        </li>
      </ul>
    </div>
  `,

  navigation3: `

    <ul class="flex flex-wrap text-sm font-medium text-center">

       <li class="me-2">
        <a href="#" v-bind:class="{ active: model.page == 'openPack', ' dark:text-[#272727] ': model.page  === 'openPack','text-[#195c36]  dark:text-white': model.page !== 'openPack'  }" v-on:click="click('openPack')" class="inline-flex items-center justify-center p-4  border-b-2 hover:text-white group" >
             <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-4 h-4 me-2"
                  viewBox="0 0 100 120"
                  v-bind:class="{ 'group-dark:text-[#272727]': model.page  ==='openPack','text-[#195c36] dark:text-white': model.page !== 'openPack'  }"
              >
                  <!-- Card 1 -->
                  <rect x="10" y="10" width="80" height="110" rx="10" ry="10" fill="#272727" stroke="#ccc" stroke-width="2"/>
                  <rect x="20" y="20" width="60" height="90" rx="8" ry="8" fill="#ffff" />

                  <!-- Card 2 -->
                  <rect x="15" y="15" width="80" height="110" rx="10" ry="10" fill="#272727" stroke="#ccc" stroke-width="2" opacity="0.8"/>
                  <rect x="25" y="25" width="60" height="90" rx="8" ry="8" fill="#ffff" />

                  <!-- Card 3 -->
                  <rect x="20" y="20" width="80" height="110" rx="10" ry="10" fill="#272727" stroke="#ccc" stroke-width="2" opacity="0.6"/>
                  <rect x="30" y="30" width="60" height="90" rx="8" ry="8" fill="#ffff" />
              </svg>
              Open Pack
          </a>
      </li>

      <li class="me-2">
        <a href="#" v-bind:class="{ active: model.page == 'cards', ' dark:text-[#272727] ': model.page  ==='cards','text-[#195c36]  dark:text-white': model.page !== 'cards'  }" v-on:click="click('cards')" class="inline-flex items-center justify-center p-4  border-b-2 hover:text-white group" >
              <svg class="w-4 h-4 me-2 hover:text-white " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm0 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 13a8.949 8.949 0 0 1-4.951-1.488A3.987 3.987 0 0 1 9 13h2a3.987 3.987 0 0 1 3.951 3.512A8.949 8.949 0 0 1 10 18Z"/>
              </svg>Cards Management
          </a>
      </li>

      <li class="me-2">
        <a href="#" v-bind:class="{ active: model.page === 'deepstats', ' dark:text-[#272727] ': model.page  === 'deepstats','text-[#195c36]  dark:text-white': model.page !== 'deepstats'  }" v-on:click="click('deepstats')" class="inline-flex items-center justify-center p-4  border-b-2 hover:text-white group" >
             
          <i class="bi-bar-chart-line-fill me-2"></i>Deep Stats
          </a>
      </li>

      <li class="me-2">
          <a href="#" v-bind:class="{ active: model.page == 'bot', 'dark:text-[#272727] ': model.page  === 'bot' ,'text-[#195c36] dark:text-white': model.page !== 'bot'  }" v-on:click="click('bot')" class="inline-flex items-center justify-center p-4 border-b-2 hover:text-white group">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" v-bind:class="{ 'group-dark:text-[#272727]': model.page  ==='bot','text-[#195c36] dark:text-white': model.page !== 'bot'  }" class="w-5 h-5 me-2 group-hover:text-white">
              <rect x="6" y="8" width="12" height="10" rx="2" ry="2"></rect>
              <path d="M6 8V6a4 4 0 0 1 8 0v2"></path>
              <circle cx="9" cy="12" r="1"></circle>
              <circle cx="15" cy="12" r="1"></circle>
              <path d="M8 16h8"></path>
              <path d="M8 18h8"></path>
              <path d="M2 22h20"></path>
            </svg>AI Bot
          </a>
      </li>
      <li class="me-2">
          <a href="#" v-bind:class="{ active: model.page == 'store', 'dark:text-[#272727]': model.page  === 'store' ,'text-[#195c36] dark:text-white': model.page !== 'store'   }" v-on:click="click('store')" class="inline-flex items-center justify-center p-4 border-b-2 hover:text-white group">
               <svg class="w-4 h-4 me-2 group-hover:text-white" v-bind:class="{ 'dark:text-[#272727]': model.page  === 'store' ,'text-[#195c36] dark:text-white dark:hover:text-white': model.page !== 'store'  }"  aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                <path d="M5.223 2.25c-.497 0-.974.198-1.325.55l-1.3 1.298A3.75 3.75 0 0 0 7.5 9.75c.627.47 1.406.75 2.25.75.844 0 1.624-.28 2.25-.75.626.47 1.406.75 2.25.75.844 0 1.623-.28 2.25-.75a3.75 3.75 0 0 0 4.902-5.652l-1.3-1.299a1.875 1.875 0 0 0-1.325-.549H5.223Z" />
                <path fill-rule="evenodd" d="M3 20.25v-8.755c1.42.674 3.08.673 4.5 0A5.234 5.234 0 0 0 9.75 12c.804 0 1.568-.182 2.25-.506a5.234 5.234 0 0 0 2.25.506c.804 0 1.567-.182 2.25-.506 1.42.674 3.08.675 4.5.001v8.755h.75a.75.75 0 0 1 0 1.5H2.25a.75.75 0 0 1 0-1.5H3Zm3-6a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1-.75-.75v-3Zm8.25-.75a.75.75 0 0 0-.75.75v5.25c0 .414.336.75.75.75h3a.75.75 0 0 0 .75-.75v-5.25a.75.75 0 0 0-.75-.75h-3Z" clip-rule="evenodd" />
              </svg>
              <p class="font-bold">Store</p>
          </a>
      </li>
    </ul>
`,

leaderBoardNavigation: `
<div data-component="leaderboard-navigation">
  <ul class="nav nav-pills justify-content-center">
    <li class="nav-item">
      <button class="nav-link" v-bind:class="{ active: model.page == 'single' }" v-on:click="click('single')">Single</button>
    </li>
    <li class="nav-item">
      <button class="nav-link" v-bind:class="{ active: model.page == 'team' }" v-on:click="click('team')">Team</button>
    </li>
    <li class="nav-item">
      <button class="nav-link" v-bind:class="{ active: model.page == 'faction' }" v-on:click="click('faction')">Faction</button>
    </li>
    <li class="nav-item">
      <button class="nav-link" v-bind:class="{ active: model.page == 'seasonal' }" v-on:click="click('seasonal')">Seasonal</button>
    </li>
    <li class="nav-item">
      <button class="nav-link" v-bind:class="{ active: model.page == 'streamer_community' }" v-on:click="click('streamer_community')">Streamer Community</button>
    </li>
  </ul>
</div>
`,

hqCardsNavigation: `
  <div data-component="hq-cards-navigation">
     <ul class="nav nav-tabs data-cards justify-content-center">
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.cards == 'yours' }" v-on:click="cards('yours')">Your Cards</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.cards == 'bone_cards' }" v-on:click="cards('bone_cards')">Special Bone Cards</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.cards == 'ascension_cards' }" v-on:click="cards('ascension_cards')">Ascension Cards</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.cards == 'delta_cards' }" v-on:click="cards('delta_cards')">Delta Cards</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.cards == 'favorites' }" v-on:click="cards('favorites')"><i class="bi bi-star"></i> Favorites</button>
        </li>
      </ul>
  </div>
`,


  settings: `
    <div data-component="settings">
      <section>
        <div class="row">
          <div class="col-12">

            <div class="row" v-for="setting in model.settings">
              <div class="col-12">
                <div class="card">
                  <div class="row setting">
                    <div class="col-6 col-md-8">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom">{{ setting.description }}</label>
                    </div>
                    <div class="col-6 col-md-4">
                      <div v-if="setting.type == 'boolean'" class="form-check form-switch">
                        <input v-model="setting.value" type="checkbox" class="form-check-input" @change="save(setting.id)">
                      </div>
                      <div v-if="setting.type == 'value'">
                        <input v-model="setting.value" type="text">
                        <button class="top-margin" data-button="submit" v-on:click="save(setting.id)">Save</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <div class="row setting">
                    <div class="col-4 col-md-8">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom">Update Twitch permissions for steam handling.</label>
                    </div>
                    <div class="col-8 col-md-4">
                      <a data-button="twitch-admin">
                        <i class="bi-twitch"></i> 
                        Connect With Twitch
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>  
  `,

  queues: `
    <div data-component="queues">
      <section>

        <div class="row">
          
          <div class="col-12">
            <div class="card">

              <div class="header">
                <h4>Current Battle</h4>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <currentBattle></currentBattle>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <div class="card">

              <div class="header">
                <h4>Open Pack Queue</h4>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <unlockQueue></unlockQueue>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div class="col-6">
            <div class="card">

              <div class="header">
                <h4>Battle Queue</h4>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <battleQueue></battleQueue>
                  </div>
                </div>
              </div>

            </div>
          </div>

          
        </div>

      <div class="row">
  
        <div class="col-6">
          <div class="card">

            <div class="header">
              <h4>Streamer Queue</h4>
            </div>

            <div class="row">
              <div class="col-12">
                <div class="row">
                <streamerBattleQueue></streamerBattleQueue>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="col-12">
            <div class="card">

              <div class="header">
                <h4>Team Battle Queue</h4>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <teamBattleQueue></teamBattleQueue>
                  </div>
                </div>
              </div>

            </div>
          </div>
      </div>

      </section>
    </div>
  `,

  mods: `
    <div data-component="queues">
      <section>

        <div class="row">
          
          <div class="col-6">
            <div class="card">

              <div class="header">
                <h4>Current Battle</h4>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <currentBattle></currentBattle>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="col-6">
            <div class="card">

              <div class="header">
                <h4>Battle Queue</h4>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <battleQueue></battleQueue>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="row">

          <div class="col-6">
              <givePack></givePack>
          </div>

          <div class="col-6">
            <div class="card">

              <div class="header">
                <h4>Open Pack Queue</h4>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <unlockQueue></unlockQueue>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>



      </section>
    </div>
  `,

  unlockQueue: `
    <div data-component="unlock-queue" class="always-display">
      <section>
        <div class="row">
          <div class="col-12">
            <div class="row columns">
              <div class="col-4">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Display Name: The users Twich display name.">User</label>
              </div>
              <div class="col-4">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Pack: The pack that is being unlocked.">Pack</label>
              </div>
              <div class="col-4"></div>
            </div>
            <div v-if="!model.hasResults">
              <h4 class="no-records">No Card Unlock Requests</h4>
            </div>
            <div v-if="model.hasResults">
              <div class="row data" v-if="unlock.active" v-for="unlock in model.unlocks">
                <div class="col-3" :title="unlock.twitchDisplayName">
                  {{ unlock.twitchDisplayName[0].twitchDisplayName }}
                </div>
                <div class="col-3" :title="model.packs[unlock.packId].name">
                  <span v-if="model.packs[unlock.packId]">{{ model.packs[unlock.packId].name }}</span>
                </div>
                <div class="col-6">
                  <button data-button="open" v-on:click="open(unlock.id)" class="small"  v-bind:class="{ 'is-disabled': unlock.disabled }">Open</button>
                  <button data-button="cancel" v-on:click="cancel(unlock.id)" class="small">Cancel</button>
                  <button data-button="open" v-on:click="sendToHq(unlock.id)" class="small"  v-bind:class="{ 'is-disabled': unlock.hq }">Send to HQ</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  `,

  HQunlockQueue: `
  <div data-component="hq-unlock-queue" class="always-display">
    <section>
      <div class="row">
        <div class="col-12">
          <div v-if="!model.hasOpen">

           <div class="row columns">
              <div class="col-4">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Display Name: The users Twich display name.">User</label>
              </div>
              <div class="col-4">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Pack: The pack that is being unlocked.">Pack</label>
              </div>
              <div class="col-4"></div>
            </div>
            <div v-if="!model.hasResults">
              <h4 class="no-records">No Card Unlock Requests</h4>
            </div>
            <div v-if="model.hasResults">
              <div class="row data" v-if="unlock.active" v-for="unlock in model.unlocks">
                <div class="col-4" :title="unlock.twitchDisplayName">
                  {{ unlock.twitchDisplayName[0].twitchDisplayName }}
                </div>
                <div class="col-4" :title="model.packs[unlock.packId].name">
                  <span v-if="model.packs[unlock.packId]">{{ model.packs[unlock.packId].name }}</span>
                </div>
                <div class="col-4">
                  <button data-button="open" v-on:click="openQueue(unlock.id)" class="small"  v-bind:class="{ 'is-disabled': unlock.disabled }">Open</button>
                  <button data-button="cancel" v-on:click="cancel(unlock.id)" class="small">Cancel</button>
                </div>
              </div>
            </div>

            

          </div>
          <div v-else>
            <div data-component="open-pack-hq" class="always-display">
              <div class="content">
                <div class="open-pack-wrapper-hq" v-bind:class="{ show: model.packLoaded }">
                  <div class="open-pack-container collapsed">
                    <div id="opened-cards" class="opened-cards-wrapper">
                      <div class="opened-cards">
                          <component
                            v-for="card in model.userCards"
                            class="scaled"
                            :key="card.id"
                            v-bind:card="card"
                            :is="card.tier >= 4 ? 'special-card' : 'playing-card'"
                            :card="card"
                            :show="'true'"
                          ></component>
               
                      </div>
                    </div>
                    <playing-card id="hq-cover" class="cover pulse" :class="model.pack.name" v-bind:card="model.card" v-bind:show="'true'"></playing-card>
                    </div>
                  </div>
                </div>
              </div>
            </div>
           

          </div>
        </div>
      </div>
    </section>
  </div>
`,

  keyQueue: `
    <div data-component="key-queue" class="always-display">
      <section>
        <div class="row">
          <div class="col-12">
            <div class="row columns">
              <div class="col-4">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Display Name: The users Twich display name.">User</label>
              </div>
              <div class="col-4">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Key: The keys name.">Key</label>
              </div>
              <div class="col-4"></div>
            </div>
            <div v-if="!model.hasResults">
              <h4 class="no-records">No Keys Uses</h4>
            </div>
            <div v-if="model.hasResults">
              <div class="row data" v-if="key.queue" v-for="key in model.keys">
                <div class="col-4" :title="key.twitchDisplayName">
                  {{ key.twitchDisplayName }}
                </div>
                <div class="col-4" :title="key.name">
                  {{ key.name }}
                </div>
                <div class="col-4">
                  <button data-button="use" v-on:click="use(key.id)" class="small">Use</button>
                  <button data-button="cancel" v-on:click="cancel(key.id)" class="small">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  `,

  battleQueue: `
    <div data-component="battle-queue" class="always-display">
      <section>
        <div class="row">
          <div class="col-12">
            <div class="row columns">
     
              <div class="col-4">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="User 1: The Twich display name of user 1.">User 1</label>
              </div>
              <!--
              <div class="col-2">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Cards 1: The cards of user 1.">Cards 1</label>
              </div>
              -->
              <div class="col-4">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="User 2: The Twich display name of user 2.">User 2</label>
              </div>
              <!--
              <div class="col-2">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Cards 2: The cards of user 2.">Cards 2</label>
              </div>
              -->
              <div class="col-4"></div>
            </div>
            <div v-if="!model.hasResults">
              <h4 class="no-records">No Card Unlock Requests</h4>
            </div>
            <div v-if="model.hasResults">
              <div class="row data" v-if="battle.queue" v-for="battle in model.battles">
                <div class="col-4" :title="battle.user1TwitchDisplayName">
                  {{ battle.twitch1DisplayName[0].twitchDisplayName }}
                </div>
                <!--
                <div class="col-2" :title="battle.user1Cards">
                  {{ battle.user1Cards }}
                </div>
                -->
                <div class="col-4" :title="battle.user2TwitchDisplayName">
                  {{ battle.twitch2DisplayName[0].twitchDisplayName }}
                </div>
                <!--
                <div class="col-2" :title="battle.user2Cards">
                  {{ battle.user2Cards }}
                </div>
                -->
                <div class="col-4">
                  <button data-button="start" v-on:click="start(battle.id)" class="small">Start</button>
                  <button data-button="cancel" v-on:click="cancel(battle.id)" class="small">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  `,

  teamBattleQueue: `
 <div data-component="battle-queue" class="always-display">
    <section>
      <div class="row">
        <div class="col-12">
          <div class="row columns">
            <div class="col-4">
              <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="User 1: The Twich display Team 1.">Team 1</label>
            </div>
            <!--
            <div class="col-2">
              <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Cards 1: The cards of user 1.">Cards 1</label>
            </div>
            -->
            <div class="col-4">
              <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="User 2: The Twich display Team 2.">Team 2</label>
            </div>
            <!--
            <div class="col-2">
              <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Cards 2: The cards of user 2.">Cards 2</label>
            </div>
            -->
            <div class="col-4">Mode</div>
          </div>
          <div v-if="!model.hasResults">
            <h4 class="no-records">No Card Unlock Requests</h4>
          </div>
          <div v-if="model.hasResults">
            <div class="row data" v-if="battle.queue" v-for="battle in model.battles">
              <div class="col-4" title="team1">
                <div v-if="battle.type == '2v2'">
                  {{ battle.twitch1DisplayName[0].twitchDisplayName }} and {{ battle.twitch2DisplayName[0].twitchDisplayName }}
                </div>
                  <div v-if="battle.type == '3v3'">
                 {{ battle.twitch1DisplayName[0].twitchDisplayName }},{{ battle.twitch2DisplayName[0].twitchDisplayName}},{{ battle.twitch3DisplayName[0].twitchDisplayName}}
                </div>
                <div v-if="battle.type == '4v4'">
                  {{ battle.twitch1DisplayName[0].twitchDisplayName }},{{ battle.twitch2DisplayName[0].twitchDisplayName}},{{ battle.twitch3DisplayName[0].twitchDisplayName}},{{ battle.twitch4DisplayName[0].twitchDisplayName}}
                </div>
              </div>
              <!--
              <div class="col-2" :title="battle.user1Cards">
                {{ battle.user1Cards }}
              </div>
              -->
              <div class="col-4" title="team2">
                <div v-if="battle.type == '2v2'">
                 {{ battle.twitch5DisplayName[0].twitchDisplayName }}, and {{ battle.twitch6DisplayName[0].twitchDisplayName}}
                </div>
                <div v-if="battle.type == '3v3'">
                  {{ battle.twitch5DisplayName[0].twitchDisplayName }},{{ battle.twitch6DisplayName[0].twitchDisplayName}},{{ battle.twitch7DisplayName[0].twitchDisplayName}}
                </div>
              <div v-if="battle.type == '4v4'">
                 {{ battle.twitch5DisplayName[0].twitchDisplayName }},{{ battle.twitch6DisplayName[0].twitchDisplayName}},{{ battle.twitch7DisplayName[0].twitchDisplayName}},{{ battle.twitch8DisplayName[0].twitchDisplayName}}
                </div>
              </div>
              <!--
              <div class="col-2" :title="battle.user2Cards">
                {{ battle.user2Cards }}
              </div>
              -->
              <div class="col-4">
                 <div class="d-flex">{{battle.type}}
                    <span class="col-sm-9 d-flex justify-content-end">
                      <button data-button="start" v-on:click="start(battle.id)" class="small">Start</button>
                      <button data-button="cancel" v-on:click="cancel(battle.id)" class="small">Cancel</button>
                    </span>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
`,

  // <div v-if="!model.hasResults">
  //           <h4 class="no-records">No users in queue</h4>
  //         </div>

  streamerBattleQueue: `
  <div data-component="battle-queue" class="always-display">
    <section>
      <div class="row">
        <div class="col-12">

          <div class="row columns">
              <div class="col-4">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="User 1: The Twich display name of user 1.">Username</label>
              </div>
              <div class="col-8"></div>
          </div>

          <div v-if="!model.hasResults">
            <h4 class="no-records">No users queued</h4>
          </div>

          <div v-if="model.hasResults">
            <div class="row data" v-for="queue in model.queues" :key="queue.twitchId">
              <div class="col-8" :title="queue.username">{{ queue.username }}</div>
              <div class="col-4">
                  <button data-button="start"  v-on:click="accept({username: queue.username, twitchId: queue.twitchId, teamName: queue.teamName})" class="small">Accept</button>
                  <button data-button="cancel" v-on:click="decline({username: queue.username, twitchId: queue.twitchId, teamName: queue.teamName})" class="small">Decline</button>
                </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  </div>
`,

  currentBattle: `
    <div data-component="current-battle" class="always-display">
      <section>
        <div class="row">
          <div class="col-12">
            <div class="row columns">
              <div class="col-4">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="User 1: The Twich display name of user 1.">User 1</label>
              </div>
              <div class="col-4">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="User 2: The Twich display name of user 2.">User 2</label>
              </div>
              <div class="col-4"></div>
            </div>
            <div v-if="!model.hasResults">
              <h4 class="no-records">No Battle Running</h4>
            </div>
            <div v-if="model.hasResults">
              <div class="row data">
                <div class="col-4" :title="model.battle.user1TwitchDisplayName">
                  {{ model.battle.user1TwitchDisplayName[0].twitchDisplayName }}
                </div>
                <div class="col-4" :title="model.battle.user2TwitchDisplayName">
                  {{ model.battle.user2TwitchDisplayName[0].twitchDisplayName  }}
                </div>
                <div class="col-4">
                  <button data-button="queue" v-on:click="queue(model.battle.id)" class="small">Queue</button>
                  <button data-button="cancel" v-on:click="cancel(model.battle.id)" class="small">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  `,

  leaderboard: `
    <div data-component="leaderboard">
      <section>
        <div class="row">
          <div class="col-12">
            <div class="card">

              <div class="header">
                <h4>Leaderboard</h4>
              </div>
              
              <div class="row">
                <div class="col-12">
                  <div class="row columns">
                    <div class="col-4 top" v-for="user in model.top">
                      <div class="user">
                        <div class="info">
                          <img :src="user.twitchProfileImage" />
                          <span class="trophy">
                            <i class="bi-trophy-fill"></i>
                          </span>
                          <p class="name" :title="user.twitchDisplayName">{{ user.twitchDisplayName }}</p>
                        </div>
                        <div class="wins">
                          <p>{{ user.wins }} Wins</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="row columns headers">
                    <div class="col-3 col-md-3">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Username</label>
                    </div>
                    <div class="col-2">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Achievements</label>
                    </div>
                    <div class="col-1 col-md-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Wins</label>
                    </div>
                    <div class="col-1 col-md-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Losses</label>
                    </div>
                    <div class="col-1 d-md-block">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Packs</label>
                    </div>
                    <div class="col-1 d-md-block">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Cards</label>
                    </div>
                    <div class="col-1 d-md-block">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title=".">Keys</label>
                    </div>
                    <div class="col-1 d-md-block">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title=".">XP</label>
                    </div>
                    <div class="col-1 d-md-block">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title=".">Level</label>
                    </div>
                  </div>
                  <div class="table">
                    <div class="row data" v-for="user in model.users">
                      <div class="col-3 col-md-3 info">
                        <img :src="user.twitchProfileImage" />
                        <p :title="user.twitchDisplayName">{{ user.twitchDisplayName }}</p>
                      </div>
                      <div class="col-2">
                        <img v-for="a in user.achievements" :data-id="a.id" :src="a.image" class="medal"/>
                      </div>
                      <div class="col-1 col-md-1">
                        <p>{{ user.wins }}</p>
                      </div>
                      <div class="col-1 col-md-1">
                        <p>{{ user.losses }}</p>
                      </div>
                      <div class="col-1 d-md-block">
                        <p>{{ user.packs }}</p>
                      </div>
                      <div class="col-1 d-md-block">
                        <p>{{ user.cards }}</p>
                      </div>
                      <div class="col-1 d-md-block">
                        <p>{{ user.keys }}</p>
                      </div>
                      <div class="col-1 d-md-block">
                        <p>{{ user.xp }}</p>
                      </div>
                       <div class="col-1 d-md-block">
                        <p>{{user.level}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </div>
        <div data-component="view-medal">
          <div class="view-element"><div></div></div>
        </div>
      </section>
    </div>
  `,

  teamLeaderBoard: `
    <div data-component="team-leaderboard">
      <h1>team leaderboard</h1>
    </div>
  `,

  factionLeaderBoard: `
    <div data-component="factionleaderboard">
      <h1>faction leaderboard</h1>
    </div>
  `,

  seasonalLeaderBoard: `
    <div data-component="seasonalleaderboard">
      <h1>season leaderboard</h1>
    </div>
  `,

  streamersCommunityLeaderBoard: `
    <div data-component="streamer_community_leaderboard">
      <h1>streamers-community leaderboard</h1>
    </div>
  `,

  admin: `
    <div data-component="admin">
      <section>
        <div class="row">
          <div class="col-12">
            <givePack></givePack>
          </div>
          <div class="col-12">
            <giveKey></giveKey>
          </div>
          <div class="col-12">
            <medalAdmin></medalAdmin>
          </div>
          <div class="col-12">
            <addMod></addMod>
          </div>
          <div class="col-12">
            <battleAdmin></battleAdmin>
          </div>
          <div class="col-12">
            <streamerBattles></streamerBattles>
          </div>
        </div>
      </section>
    </div>
  `,

  givePack: `
    <div data-component="give-pack" class="always-display">
      <div class="card">

        <div class="header margin">
          <h4>Give Pack</h4>
          <button class="top-margin" data-button="submit" v-on:click="save()">Save</button>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-4">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Display Name: Type the Twitch display name you are looking for.">Display Name</label>
                <input class="form-control search" name="unlock-user" v-on:keyup="searchUsers()" type="text">
              </div>
              <div class="col-4">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select Pack: Select a pack you want to give to a user.">Select Pack</label>
                <select class="form-select" v-model="model.packId">
                  <option v-for="(value, key) in model.packs" v-bind:value="key">
                    {{ value.name }}
                  </option>
                </select>
              </div>
              <div class="col-2">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Send to User's HQ.">Send to HQ</label>
                <div class="form-check form-switch"><input type="checkbox" class="form-check-input" @click="toggle"></div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  `,

  streamerBattles: `
  <div data-component="streamer-battles" class="always-display">
    <div class="card">
      <div class="row setting">
        <div class="col-6 col-md-8">
          <label data-bs-toggle="tooltip" data-bs-placement="bottom">Streamer Battles</label>
        </div>
        <div class="col-6 col-md-4">
          <div  class="form-check form-switch">
            <input type="checkbox" v-model="model.state" class="form-check-input" @change="saveStreamerBattleState($event)" />
          </div>
        </div>
      </div>
    </div>
  </div>
`,

streamerBattles1: `
<div data-component="streamer-battles" class="always-display">
  <div class="card">
    <div class="row setting">
      <div class="col-6 col-md-8">
        <label data-bs-toggle="tooltip" data-bs-placement="bottom">Streamer Battles</label>
      </div>
      <div class="col-6 col-md-4">
        <div  class="form-check form-switch">
          <input type="checkbox" v-model="model.state" class="form-check-input" @change="saveStreamerBattleState($event)" />
        </div>
      </div>
    </div>
  </div>
</div>
`,

  giveKey: `
    <div data-component="give-key" class="always-display">
      <div class="card">

        <div class="header margin">
          <h4>Give Keys</h4>
          <button class="top-margin" data-button="submit" v-on:click="save()">Save</button>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-3">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Display Name: Type the Twitch display name you are looking for.">Display Name</label>
                <input class="form-control search" name="key-user" v-on:keyup="searchUsers()" type="text">
              </div>
              <div class="col-3">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select Key: Select a key you want to give to a user.">Select Key</label>
                <select class="form-select" v-model="model.keyId">
                  <option v-for="(value, key) in model.keys" v-bind:value="key">
                    {{ value.name }} - {{ value.description }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  `,

  addMod: `
    <div data-component="add-mod" class="always-display">
      <div class="card">

        <div class="header margin">
          <h4>Add Mod</h4>
          <button class="top-margin" data-button="submit" v-on:click="save()">Save</button>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-3">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Display Name: Type the Twitch display name you are looking for.">Display Name</label>
                <input class="form-control search" name="mod-user" v-on:keyup="searchUsers()" type="text">
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  `,

  battleAdmin: `
    <div data-component="battle-admin" class="always-display">
      <div class="card">

        <div class="header margin">
          <h4>Battles</h4>
          <button class="top-margin" data-button="submit" v-on:click="save()">Save</button>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-3">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="User 1: Search for Twich display name of user 1.">User 1 Display Name</label>
                <input class="form-control search" name="battle-user1" v-on:keyup="searchUsers('battle-user1')"  type="text">
              </div>
              <div class="col-2">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Cards 1: Enter the cards for user 1.">Cards 1</label>
                <input class="form-control" v-model="model.battle.user1Cards" type="text">
              </div>
              <div class="col-3">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="User 2: Search for Twich display name of user 1.">User 2 Display Name</label>
                <input class="form-control search" name="battle-user2" v-on:keyup="searchUsers('battle-user2')" type="text">
              </div>
              <div class="col-2">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Cards 2: Enter the cards for user 2.">Cards 2</label>
                <input class="form-control" v-model="model.battle.user2Cards" type="text">
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  `,

  medalAdmin: `
    <div data-component="medal-admin" class="always-display">
      <div class="card">

        <div class="header margin">
          <h4>Achievements</h4>
          <button class="top-margin" data-button="submit" v-on:click="add()">Save</button>
          <button class="top-margin" data-button="submit" v-on:click="get()">Get</button>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-3">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="User 1: Search for Twich display name of the users medal you want to load.">Display Name</label>
                <input class="form-control search" name="medal-user" v-on:keyup="searchUsers()" type="text">
              </div>
              <div class="col-3">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select Achievement: Select a medal you want to give to a user.">Select Achievement</label>
                <select class="form-select" v-model="model.medalId">
                  <option v-for="(value, key) in model.allMedals" v-bind:value="key">
                    {{ value.name }} - {{ value.description }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="row columns">
              <div class="col-11">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Medal Name: The name of the medal the user has.">Medal</label>
              </div>
              <div class="col-1 edit">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Delete: Click to delete the medal.">Delete</label>
              </div>
            </div>
            <div v-if="!model.hasResults">
              <h4 class="no-records">{{ model.error }}</h4>
            </div>
            <div v-if="model.hasResults">
              <div class="row data" v-for="medal in model.medals" v-if="!medal.deleted">
                <div class="col-11">
                  {{ medal.name }}
                </div>
                <div class="col-1 edit">
                  <i class="bi-trash" v-on:click="remove(medal.id)"></i> 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,

  cardAbiltities: `
    <div data-component="card-abilities">
      <section>
        <div class="row">
          <div class="col-12">
            <div class="card">

              <div class="header">
                <h4>Abilities</h4>
                <button class="top-margin" data-button="submit" v-on:click="add()">Add</button>
              </div>

              <div class="row form" v-bind:class="{ visible: model.edit }">
                <div>
                  <i class="bi-x-lg close" v-on:click="reset()"></i> 
                  <div class="col-12">
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables an ability so it can be used.">Active</label>
                      <div class="form-check form-switch">
                        <input v-model="model.ability.active" type="checkbox" class="form-check-input">
                      </div>
                    </div>
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: Abilities name.">Name</label>
                      <input class="form-control" v-model="model.ability.name" type="text">
                    </div>
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: Detailed description of how the ability works.">Description</label>
                      <input class="form-control" v-model="model.ability.description" type="text">
                    </div>
                    <button class="top-margin" data-button="submit" v-on:click="save()">Save</button>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="row columns">
                    <div class="col-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables an ability so it can be used.">Active</label>
                    </div>
                    <div class="col-2">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: Abilities name.">Name</label>
                    </div>
                    <div class="col-4">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: Detailed description of how the ability works.">Description</label>
                    </div>
                    <div class="col-4">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Function ID: Used in the abilities file to name the functions.">Function ID</label>
                    </div>
                    <div class="col-1 edit">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Edit: Click the row to edit the specific record.">Edit</label>
                    </div>
                  </div>
                  <div class="table">
                    <div class="row data" v-for="ability in model.abilities" v-on:click="edit(ability.id)">
                      <div class="col-1">
                        <i v-if="ability.active == true" class="bi-check-lg"></i> 
                        <i v-if="ability.active == false"class="bi-x-lg"></i> 
                      </div>
                      <div class="col-2">
                        {{ ability.name }}
                      </div>
                      <div class="col-4">
                        {{ ability.description }}
                      </div>
                      <div class="col-4">
                        {{ ability.id }}
                      </div>
                      <div class="col-1 edit">
                        <i class="bi-pencil"></i> 
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </div>
  `,

  cardTypes: `
  <div data-component="card-types">
    <section>
      <div class="row">
        <div class="col-12">
          <div class="card">

            <div class="header">
              <h4>Types</h4>
              <button class="top-margin" data-button="submit" v-on:click="add()">Add</button>
            </div>

            <div class="row form" v-bind:class="{ visible: model.edit }">
              <div>
                <i class="bi-x-lg close" v-on:click="reset()"></i> 
                <div class="col-12">
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables an card type so it can be used.">Active</label>
                    <div class="form-check form-switch">
                      <input v-model="model.type.active" type="checkbox" class="form-check-input">
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: Card types name.">Name</label>
                    <input class="form-control" v-model="model.type.name" type="text">
                  </div>
                  <button class="top-margin" data-button="submit" v-on:click="save()">Save</button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="row columns">
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables an card type so it can be used.">Active</label>
                  </div>
                  <div class="col-10">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: Card types name.">Name</label>
                  </div>
                  <div class="col-1 edit">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Edit: Click the row to edit the specific record.">Edit</label>
                  </div>
                </div>
                <div class="table">
                  <div class="row data" v-for="type in model.types" v-on:click="edit(type.id)">
                    <div class="col-1">
                      <i v-if="type.active == true" class="bi-check-lg"></i> 
                      <i v-if="type.active == false"class="bi-x-lg"></i>
                    </div>
                    <div class="col-10">
                      {{ type.name }}
                    </div>
                    <div class="col-1 edit">
                      <i class="bi-pencil"></i> 
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  </div>
  `,

  packs: `
  <div data-component="packs">
    <section>
      <div class="row">
        <div class="col-12">
          <div class="card">

            <div class="header">
              <h4>Packs</h4>
              <button class="top-margin" data-button="submit" v-on:click="add()">Add</button>
            </div>

            <div class="row form" v-bind:class="{ visible: model.edit }">
              <div>
                <i class="bi-x-lg close" v-on:click="reset()"></i> 
                <div class="col-12 scroll_sidebar">
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables the pack so it can be unlocked.">Active</label>
                    <div class="form-check form-switch">
                      <input v-model="model.pack.active" type="checkbox" class="form-check-input">
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: The packs name. To allow it to be redeemed via channel points it's name must match the channel points name.">Name</label>
                    <input class="form-control" v-model="model.pack.name" type="text">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Size: How many cards the pack contains.">Size</label>
                    <input class="form-control" v-model="model.pack.size" type="number">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Size: How many times this pack can be redeemed.">Limit</label>
                    <input class="form-control" v-model="model.pack.limit" type="number">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Ultra Chance: What percentage chance that an ultra will be unlocked in this pack.">Ultra</label>
                    <div class="input-group">
                      <input type="number" class="form-control" v-model="model.pack.ultraChance">
                    <span class="input-group-text">%</span>
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Legendary Chance: What percentage chance that a legendary will be unlocked in this pack.">Legendary</label>
                    <div class="input-group">
                      <input type="number" class="form-control" v-model="model.pack.legendaryChance">
                    <span class="input-group-text">%</span>
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Ultimate Chance: What percentage chance that an ultimate will be unlocked in this pack.">Ultimate</label>
                    <div class="input-group">
                      <input type="number" class="form-control" v-model="model.pack.ultimateChance">
                    <span class="input-group-text">%</span>
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Bone Card Chance: What percentage chance that a bone card will be unlocked in this pack.">Bone Card</label>
                    <div class="input-group">
                      <input type="number" class="form-control" v-model="model.pack.boneCardChance">
                      <span class="input-group-text">%</span>
                    </div>
                  </div>
                    <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Ascension Card Chance: What percentage chance that a ascension card will be unlocked in this pack.">Ascension Card</label>
                    <div class="input-group">
                      <input type="number" class="form-control" v-model="model.pack.ascChance">
                      <span class="input-group-text">%</span>
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Ultra Guaranteed: Guarantees an ultra will be unlocked in this pack.">Ultra Guaranteed</label>
                    <div class="form-check form-switch">
                      <input v-model="model.pack.ultraGuaranteed" type="checkbox" class="form-check-input">
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Legendary Guaranteed: Guarantees a legendary will be unlocked in this pack.">Legendary Guaranteed</label>
                    <div class="form-check form-switch">
                      <input v-model="model.pack.legendaryGuaranteed" type="checkbox" class="form-check-input">
                    </div>
                  </div>
<button class="top-margin" data-button="submit" v-on:click="save()">Save</button>                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="row columns">
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables the pack so it can be unlocked.">Active</label>
                  </div>
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: The packs name. To allow it to be redeemed via channel points it's name must match the channel points name.">Name</label>
                  </div>
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Size: How many cards the pack contains.">Size</label>
                  </div>
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Limit: How many times this pack can be redeemed.">Limit</label>
                  </div>
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Ultra Chance: What percentage chance that an ultra will be unlocked in this pack.">Ultra</label>
                  </div>
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Legendary Chance: What percentage chance that a legendary will be unlocked in this pack.">Legendary</label>
                  </div>
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Ultimate Chance: What percentage chance that an ultimate will be unlocked in this pack.">Ultimate</label>
                  </div>
                    <div class="col-1">
                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Bone Card Guaranteed: Guarantees a Bone Card will be unlocked in this pack.">Bone Card GTD</label>
                  </div>
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Ascension Guaranteed: Guarantees a Ascension will be unlocked in this pack.">ASC GTD</label>
                  </div>
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Ultra Guaranteed: Guarantees an ultra will be unlocked in this pack.">ULT GTD</label>
                  </div>
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Legendary Guaranteed: Guarantees a legendary will be unlocked in this pack.">LGY GTD</label>
                  </div>
                  <div class="col-1 edit">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Edit: Click the row to edit the specific record.">Edit</label>
                  </div>
                </div>
                <div class="table">
                  <div class="row data" v-for="pack in model.packs" v-on:click="edit(pack.id)">
                    <div class="col-1">
                      <i v-if="pack.active == true" class="bi-check-lg"></i> 
                      <i v-if="pack.active == false"class="bi-x-lg"></i> 
                    </div>
                    <div class="col-1" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="pack.name">
                      {{ pack.name }}
                    </div>
                    <div class="col-1">
                      {{ pack.size }}
                    </div>
                    <div class="col-1">
                      {{ pack.limit }}
                    </div>
                    <div class="col-1">
                      {{ pack.ultraChance }}%
                    </div>
                    <div class="col-1">
                      {{ pack.legendaryChance }}%
                    </div>
                    <div class="col-1">
                      {{ pack.ultimateChance }}%
                    </div>
                    <div class="col-1">
                        {{ pack.boneCardChance }}%
                    </div>
                    <div class="col-1">
                        {{ pack.ascChance }}%
                    </div>
                    <div class="col-1">
                      <i v-if="pack.ultraGuaranteed == true" class="bi-check-lg"></i> 
                      <i v-if="pack.ultraGuaranteed == false"class="bi-x-lg"></i> 
                    </div>
                    <div class="col-1">
                      <i v-if="pack.legendaryGuaranteed == true" class="bi-check-lg"></i> 
                      <i v-if="pack.legendaryGuaranteed == false"class="bi-x-lg"></i> 
                    </div>
                    <div class="col-1 edit">
                      <i class="bi-pencil"></i> 
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  </div>
  `,

  cards: `
  <div data-component="cards">
    <section>
      <div class="row">
        <div class="col-12">
          <div class="card">

            <div class="header">
              <h4>Cards</h4>
              <button class="top-margin" data-button="submit" v-on:click="add()">Add</button>
            </div>

            <div class="row form" v-bind:class="{ visible: model.edit }">
              <div>
                <i class="bi-x-lg close" v-on:click="reset()"></i> 
                <div class="col-12">
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables a card to be unlocked or used in a battle.">Active</label>
                    <div class="form-check form-switch">
                      <input v-model="model.card.active" type="checkbox" class="form-check-input">
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: The card's name.">Name</label>
                    <input class="form-control" v-model="model.card.name" type="text">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Type: The card's type.">Type</label>
                    <select class="form-select" v-model="model.card.type">
                      <option v-for="(value, key) in model.types" v-bind:value="key">
                        {{ value.name }}
                      </option>
                    </select>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Ability: The card's ability.">Ability</label>
                    <select class="form-select" v-model="model.card.ability">
                      <option value="">No Ability Selected</option>
                      <option v-for="(value, key) in model.abilities" v-bind:value="key">
                      {{ value.name }} - {{ value.description }}
                      </option>
                    </select>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="HP: The card's hit points.">HP</label>
                    <input class="form-control" v-model="model.card.hp" type="number">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Attack: The card's attack points.">Attack</label>
                    <input class="form-control" v-model="model.card.attack" type="number">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Defense: The card's defense points.">Defence</label>
                    <input class="form-control" v-model="model.card.defence" type="number">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Accuracy: The card's attach accuracy.">Accuracy</label>
                    <input class="form-control" v-model="model.card.accuracy" type="number">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Speed: The card's speed points.">Speed</label>
                    <input class="form-control" v-model="model.card.speed" type="number">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Ultimate: If the card is an ultimate.">Ultimate</label>
                    <div class="form-check form-switch">
                      <input v-model="model.card.ultimate" type="checkbox" class="form-check-input">
                    </div>
                  </div>
                  <button class="top-margin" data-button="submit" v-on:click="save()">Save</button>
                  <div v-if="model.card.id"  class="upload">
                    <button data-button="upload">Upload</button>
                    <input type="file" id="file" ref="file" @change="upload"/>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div class="row columns">
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables a card to be unlocked or used in a battle.">Active</label>
                  </div>
                  <div class="col-2">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: The card's name.">Name</label>
                  </div>
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="HP: The card's hit points.">HP</label>
                  </div>
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Attack: The card's attack points.">Attack</label>
                  </div>
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Defense: The card's defense points.">Defence</label>
                  </div>
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Speed: The card's speed points.">Speed</label>
                  </div>
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Accuracy: The card's attach accuracy.">Accuracy</label>
                  </div>
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Type: The card's type.">Type</label>
                  </div>
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Ability: The card's ability.">Ability</label>
                  </div>
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Ultimate: If the card is an ultimate.">Ultimate</label>
                  </div>
                  <div class="col-1 edit">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Edit: Click the row to edit the specific record.">Edit</label>
                  </div>
                </div>
                <div class="table">
                  <div class="row data" v-for="card in model.cards" v-on:click="edit(card.id)">
                    <div class="col-1">
                      <i v-if="card.active == true" class="bi-check-lg"></i> 
                      <i v-if="card.active == false" class="bi-x-lg"></i> 
                    </div>
                    <div class="col-2" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="card.name">
                      {{ card.name }}
                    </div>
                    <div class="col-1">
                      {{ card.hp }}
                    </div>
                    <div class="col-1">
                      {{ card.attack }}
                    </div>
                    <div class="col-1">
                      {{ card.defence }}
                    </div>
                    <div class="col-1">
                      {{ card.speed }}
                    </div>
                    <div class="col-1">
                      {{ card.accuracy }}
                    </div>
                    <div class="col-1" title>
                      <span data-bs-toggle="tooltip" data-bs-placement="bottom" v-if="model.types[card.type]" :title="model.types[card.type].name">{{ model.types[card.type].name }}</span>
                    </div>
                    <div class="col-1" title>
                      <span data-bs-toggle="tooltip" data-bs-placement="bottom" v-if="model.abilities[card.ability]" :title="model.abilities[card.ability].description">{{ model.abilities[card.ability].name }}</span>
                    </div>
                    <div class="col-1">
                      <i v-if="card.ultimate == true" class="bi-check-lg"></i> 
                      <i v-if="card.ultimate == false"class="bi-x-lg"></i> 
                    </div>
                    <div class="col-1 edit">
                      <i class="bi-pencil"></i> 
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </section>
  </div>
  `,

  specialCards: `
  <div data-component="special-cards">
    <section>
      <div class="row">
        <div class="col-12">
          <div class="card">

            <div class="header">
              <h4>Cards</h4>
              <button class="top-margin" data-button="submit" v-on:click="add()">Add</button>
            </div>

            <div class="row form" v-bind:class="{ visible: model.edit }">
              <div>
                <i class="bi-x-lg close" v-on:click="reset()"></i> 
                <div class="col-12">
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables a card to be unlocked or used in a battle.">Active</label>
                    <div class="form-check form-switch">
                      <input v-model="model.card.active" type="checkbox" class="form-check-input">
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: The card's name.">Name</label>
                    <input class="form-control" v-model="model.card.name" type="text">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Limit: card usage limit.">Limit</label>
                    <input class="form-control" v-model="model.card.userLimit" type="number">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="XP Multiplier: card xp multiplier.">XP Multiplier</label>
                    <input class="form-control" v-model="model.card.xpMultiplier" type="number" step="any">
                  </div>
  
                  <button class="top-margin" data-button="submit" v-on:click="save()">Save</button>
                  
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div class="row columns">
                  <div class="col-2">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables a card to be unlocked or used in a battle.">Active</label>
                  </div>
                  <div class="col-4">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: The card's name.">Name</label>
                  </div>
                  <div class="col-2">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Limit: The number of card uses allowed">Limit</label>
                  </div>
                  <div class="col-2">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="XP Multipier: The multiplying factor of XP gotten">XP Multiplier</label>
                  </div>
                  <div class="col-2 edit">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Edit: Click the row to edit the specific record.">Edit</label>
                  </div>
                </div>
                <div class="table">
                  <div class="row data" v-for="card in model.cards" v-on:click="edit(card.id)">
                    <div class="col-2">
                      <i v-if="card.active == true" class="bi-check-lg"></i> 
                      <i v-if="card.active == false" class="bi-x-lg"></i> 
                    </div>
                    <div class="col-4" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="card.name">
                      {{ card.name }}
                    </div>
                    <div class="col-2">
                      {{ card.userLimit }}
                    </div>
                    <div class="col-2">
                      {{ card.xpMultiplier }}
                    </div>
                    <div class="col-2 edit">
                      <i class="bi-pencil"></i> 
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </section>
  </div>
  `,

  boneCards: `
  <div data-component="bone-cards">
    <section>
      <div class="row">
        <div class="col-12">
          <div class="card">

            <div class="header">
              <h4>Bone Cards</h4>
              <button class="top-margin" data-button="submit" v-on:click="add()">Add</button>
            </div>
            
             <div class="row form" v-bind:class="{ visible: model.edit }">
              <div>
                <i class="bi-x-lg close" v-on:click="reset()"></i> 
                <div class="col-12">
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables a card to be unlocked or used.">Active</label>
                    <div class="form-check form-switch">
                      <input v-model="model.card.active" type="checkbox" class="form-check-input">
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: The card's name.">Name</label>
                    <input class="form-control" v-model="model.card.name" type="text">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Limit: card usage limit.">Description</label>
        
                     <textarea name="w3review" rows="4" cols="50" class="form-control" v-model="model.card.description"></textarea>
                  </div>
                       <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Value: value of the bone card.">Value</label>
                    <input class="form-control" v-model="model.card.value" type="number">
                  </div>
  
                  <button class="top-margin" data-button="submit" v-on:click="save()">Save</button>
                  
                </div>
              </div>
            </div>

             <div class="row">
              <div class="col-12">
                <div class="row columns">
                  <div class="col-2">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables a card to be unlocked or used in a battle.">Active</label>
                  </div>
                  <div class="col-2">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: The card's name.">Name</label>
                  </div>
                  <div class="col-4">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Limit: The description of the bone card">Description</label>
                  </div>
                  <div class="col-2">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Value: The value of the bone card ">Value</label>
                  </div>
                  <div class="col-2 edit">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Edit: Click the row to edit the specific record.">Edit</label>
                  </div>
                </div>
                <div class="table">
                  <div class="row data" v-for="card in model.cards" v-on:click="edit(card.id)">
                    <div class="col-2">
                      <i v-if="card.active == true" class="bi-check-lg"></i> 
                      <i v-if="card.active == false" class="bi-x-lg"></i> 
                    </div>
                    <div class="col-2" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="card.name">
                      {{ card.name }}
                    </div>
                    <div class="col-4">
                      {{ card.description }}
                    </div>
                    <div class="col-2">
                      {{ card.value }}
                    </div>
                    <div class="col-2 edit">
                      <i class="bi-pencil"></i> 
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  </div>
  `,

  adminKeys: `
    <div data-component="admin-keys">
      <section>
        <div class="row">
          <div class="col-12">
            <div class="card">

              <div class="header">
                <h4>Keys</h4>
                <button class="top-margin" data-button="submit" v-on:click="add()">Add</button>
              </div>

              <div class="row form" v-bind:class="{ visible: model.edit }">
                <div>
                  <i class="bi-x-lg close" v-on:click="reset()"></i> 
                  <div class="col-12">
                    <div> 
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables an key so it can be used.">Active</label>
                      <div class="form-check form-switch">
                        <input v-model="model.key.active" type="checkbox" class="form-check-input">
                      </div>
                    </div>
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: Key name.">Name</label>
                      <input class="form-control" v-model="model.key.name" type="text">
                    </div>
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: Detailed description of how the key works.">Description</label>
                      <input class="form-control" v-model="model.key.description" type="text">
                    </div>
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Uses: How many times the key can be used. 0 equals infiniate.">Uses</label>
                      <input class="form-control" v-model="model.key.uses" type="number">
                    </div>
                    <button class="top-margin" data-button="submit" v-on:click="save()">Save</button>
                    <div v-if="model.key.id"  class="upload">
                      <button data-button="upload">Upload</button>
                      <input type="file" id="file" ref="file" @change="upload"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="row columns">
                    <div class="col-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables an key so it can be used.">Active</label>
                    </div>
                    <div class="col-3">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: Key name.">Name</label>
                    </div>
                    <div class="col-4">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: Detailed description of how the key works.">Description</label>
                    </div>
                    <div class="col-2">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Uses: How many times the key can be used. 0 equals infiniate.">Uses</label>
                    </div>
                    <div class="col-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Image/Video: Click the icons to view the uploaded image or video.">Image/Video</label>
                    </div>
                    <div class="col-1 edit">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Edit: Click the row to edit the specific record.">Edit</label>
                    </div>
                  </div>
                  <div>
                    <div class="row data" v-for="key in model.keys" v-on:click="edit(key.id)">
                      <div class="col-1">
                        <i v-if="key.active == true" class="bi-check-lg"></i> 
                        <i v-if="key.active == false"class="bi-x-lg"></i> 
                      </div>
                      <div class="col-3">
                        {{ key.name }}
                      </div>
                      <div class="col-4">
                        {{ key.description }}
                      </div>
                      <div class="col-2">
                        {{ key.uses }}
                      </div>
                      <div class="col-1">
                        <a :href="key.image" target="_blank"><i class="bi-file-earmark-image"></i></a>
                        <a :href="key.video" target="_blank"><i class="bi-file-earmark-play"></i></a>
                      </div>
                      <div class="col-1 edit">
                        <i class="bi-pencil"></i> 
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </div>
  `,

  adminMedals: `
    <div data-component="admin-medals">
      <section>
        <div class="row">
          <div class="col-12">
            <div class="card">

              <div class="header">
                <h4>Achievements</h4>
                <button class="top-margin" data-button="submit" v-on:click="add()">Add</button>
                </div>

                <div class="row form" v-bind:class="{ visible: model.edit }">
                  <div>
                    <i class="bi-x-lg close" v-on:click="reset()"></i> 
                    <div class="col-12">
                      <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables an medal so it can be used.">Active</label>
                      <div class="form-check form-switch">
                        <input v-model="model.medal.active" type="checkbox" class="form-check-input">
                      </div>
                    </div>
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: Medal name.">Name</label>
                      <input class="form-control" v-model="model.medal.name" type="text">
                    </div>
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: Detailed description of how the medal works.">Description</label>
                      <input class="form-control" v-model="model.medal.description" type="text">
                    </div>
                    <button class="top-margin" data-button="submit" v-on:click="save()">Save</button>
                    <div v-if="model.medal.id" class="upload">
                      <button data-button="upload">Upload</button>
                      <input type="file" id="file" ref="file" @change="upload"/>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="row">
                <div class="col-12">
                  <div class="row columns">
                    <div class="col-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables an medal so it can be used.">Active</label>
                    </div>
                    <div class="col-3">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: Medal name.">Name</label>
                    </div>
                    <div class="col-6">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: Detailed description of how the medal works.">Description</label>
                    </div>
                    <div class="col-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Image/Video: Click the icons to view the uploaded image or video.">Image/Video</label>
                    </div>
                    <div class="col-1 edit">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Edit: Click the row to edit the specific record.">Edit</label>
                    </div>
                  </div>
                  <div>
                    <div class="row data" v-for="medal in model.medals" v-on:click="edit(medal.id)">
                      <div class="col-1">
                        <i v-if="medal.active == true" class="bi-check-lg"></i> 
                        <i v-if="medal.active == false"class="bi-x-lg"></i> 
                      </div>
                      <div class="col-3">
                        {{ medal.name }}
                      </div>
                      <div class="col-6">
                        {{ medal.description }}
                      </div>
                      <div class="col-1">
                        <a :href="medal.image" target="_blank"><i class="bi-file-earmark-image"></i></a>
                        <a :href="medal.video" target="_blank"><i class="bi-file-earmark-play"></i></a>
                      </div>
                      <div class="col-1 edit">
                        <i class="bi-pencil"></i> 
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </div>
  `,

  adminStore:`
     <div data-component="admin-store">
      <section>
        <div class="row">
          <div class="col-12">
            <div class="card">

              <div class="header">
                <h4>Store Settings</h4>
                <button class="top-margin" data-button="submit" v-on:click="add()">Add</button>
            
                <div class="row form" v-bind:class="{ visible: model.edit }">
                  <div>
                    <i class="bi-x-lg close" v-on:click="reset()"></i> 
                    <div class="col-12">
                      <div>
                      
                    </div>
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: Store name.">Name</label>
                      <input class="form-control" v-model="model.store.name" type="text">
                    </div>
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: Detailed description of how the store works.">Description</label>
                      <input class="form-control" v-model="model.store.description" type="text">
                    </div>
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: Store Price.">Price</label>
                      <input class="form-control" v-model="model.store.price" type="number">
                    </div>
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: Enter the prefix of the store.">Prefix</label>
                      <input class="form-control" v-model="model.store.prefix" type="text">
                    </div>
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: Enter the tier number of the store.">Tier</label>
                      <input class="form-control" v-model="model.store.tier" type="number" max="3">
                    </div>
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom">Enable Cooldown</label>
                      <div class="form-check form-switch"><input type="checkbox" v-model="model.cooldownEnabled"  class="form-check-input"></div>
                    </div>
                    <div v-if="model.cooldownEnabled">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" >Cooldown Time (in hours)</label>
                      <input class="form-control" v-model="model.store.item_cooldown" type="number">
                    </div>
                    <div v-if="model.store.tier > 1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Card Tier: select tier of card.">Card Tier</label>
                      <select class="form-select mb-6" v-model="model.store.cardTier"  v-on:change="selectedTier">
                        <option value="">Select Card Tier</option>
                        <option v-for="tier in model.cardTier" :value="tier">{{ tier.name }}</option>
                      </select>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: card value.">Cards Sacrifice</label>
                      <input class="form-control" v-model="model.store.dumpCard" type="number">
                    </div>
                    <div v-if="model.store.prefix === 'sf'">
                      <div>
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: card value.">Standard</label>
                        <input class="form-control" v-model="model.store.standard" type="number">
                      </div>
                       <div>
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: card value.">Ultra</label>
                        <input class="form-control" v-model="model.store.ultra" type="number">
                      </div>
                       <div>
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: card value.">Legendary</label>
                        <input class="form-control" v-model="model.store.legendary" type="number">
                      </div>
                      <div>
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: card value.">Ultimate</label>
                        <input class="form-control" v-model="model.store.ultimate" type="number">
                      </div>
                    </div>
                 
                 
                    <button class="top-margin" data-button="submit" v-on:click="save()">Save</button>
                  </div>
                </div>
              </div>
              </div>
              
               <div class="row">
                <div class="col-12">
                  <div class="row columns">
                    <div class="col-2">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: Medal name.">Name</label>
                    </div>
                    <div class="col-3">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: Detailed description of how the medal works.">Description</label>
                    </div>
                    <div class="col-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Price: price.">Price</label>
                    </div>
                    <div class="col-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Prefix: prefix.">Prefix</label>
                    </div>
                    <div class="col-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Cooldown: Cooldown.">Cooldown</label>
                    </div>
                    <div class="col-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Tier: tier.">Tier</label>
                    </div>
                    <div class="col-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Tier: tier.">Cards Sacrifice</label>
                    </div>
                    <div class="col-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Tier: tier.">Card Sacrifice count</label>
                    </div>
                    <div class="col-1 edit">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Edit: Click the row to edit the specific record.">Edit</label>
                    </div>
                  </div>
                  <div>
                    <div class="row data" v-for="store in model.stores" v-on:click="edit(store.id)">
                      <div class="col-2">
                        {{ store.name }}
                      </div>
                      <div class="col-3">
                         <label data-bs-toggle="tooltip" data-bs-placement="bottom" :title=" store.description ">{{ store.description }}</label>
                      </div>
                      <div class="col-1">
                        {{ store.price }}
                      </div>
                       <div class="col-1">
                        {{ store.prefix }}
                      </div>
                       <div class="col-1">
                        {{ store.item_cooldown }}
                      </div>
                       <div class="col-1">
                        {{ store.tier }}
                      </div>
                      <div class="col-1">
                        {{ store.cardTier.name }}
                      </div>
                      <div class="col-1">
                        {{ store.dumpCard }}
                      </div>

                      <div class="col-1 edit">
                        <i class="bi-pencil"></i> 
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </div>
              

            </div>
          </div>
        </div>
      </section>
    </div>
  `,

  adminQuestLine:`
  <div data-component="admin-quest-line">
   <section>
     <div class="row">
       <div class="col-12">
         <div class="card">

           <div class="header">
             <h4>Quest Liner/Builder</h4>
             <button class="top-margin" data-button="submit" v-on:click="add()">Add</button>
         
             <div class="row form" v-bind:class="{ visible: model.edit }">
               <div>
                 <i class="bi-x-lg close" v-on:click="reset()"></i> 
                 <div class="col-12 scroll_sidebar">
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Level: required level.">Level Required</label>
                      <input class="form-control" v-model="model.quest.level" type="number">
                    </div>
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: Quest name.">Quest Name</label>
                      <input class="form-control" v-model="model.quest.name" type="text">
                    </div>
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: Quest rule.">Quest Rules</label>
                      <input class="form-control" v-model="model.quest.description" type="text">
                    </div>
                    <div>
                      <div class="radio-input">
                        <label>
                          <input type="radio" class="input" name="options" value="to_win" v-model="model.quest.selectedMode">
                          To win
                        </label>
                        <label>
                          <input type="radio" class="input" name="options" value="to_defeat" v-model="model.quest.selectedMode">
                          To defeat
                        </label>
                        <label>
                          <input type="radio" class="input" name="options" value="any" v-model="model.quest.selectedMode">
                          Any
                        </label>
                      </div>
                    </div>
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: Quest rule.">Card Amount</label>
                      <input class="form-control" v-model="model.quest.card_amount" type="Number" @input="generateCards">
                    </div>
                    <div v-if="model.quest.card_amount > 0">
                      <div v-for="(n, index) in parseInt(model.quest.card_amount)">
                        <div>
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select Achievement: Select a medal you want to give to a user.">Card {{n}}</label>
                          <select class="form-select" v-model="model.quest.cards[index].cardId">
                            <option v-for="(value, key) in model.cards" v-bind:value="key">
                              {{ value.name }}
                            </option>
                          </select>
                        </div>
                        <div>
                          <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select Achievement: Select a medal you want to give to a user.">Card Tier {{n}}</label>
                           <input class="form-control" v-model="model.quest.cards[index].tier" type="Number">
                        </div>
                      </div>
                    </div>
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Data: when will the quest start">Date</label>
                      <input class="form-control" v-model="model.quest.date" type="date">
                    </div>
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Time: when will the quest start">Time</label>
                      <input class="form-control" v-model="model.quest.time" type="time">
                    </div>
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Wins: how many wins needed to finish the quest">Wins needed</label>
                      <input class="form-control" v-model="model.quest.wins" type="number">
                    </div>
                    <div>
                      <div> 
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Card Tier: select tier of card.">Select Reward</label>
                        <select class="form-select" v-model="model.quest.reward" v-on:change="selectedReward">
                          <option v-for="(value, key) in model.questReward" v-bind:value="key">
                            {{ value.name }}
                          </option>
                        </select>
                      </div>
                      <div v-if="model.quest.reward === 0">
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: Detailed description of how the store works.">XP value</label>
                        <input class="form-control" v-model="model.quest.xp" type="number">
                      </div>
                      <div v-if="model.quest.reward === 1">
                        <div>
                          <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: Detailed description of how the store works.">Select Packs</label>
                            <select class="form-select" v-model="model.quest.givePack.packId">
                              <option v-for="(value, key) in model.packs" v-bind:value="key">
                                {{ value.name }}
                              </option>
                            </select>
                        </div>
                        <div>
                          <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Packs Quantity: Quantity of the packs that will be given.">Quantity</label>
                          <input class="form-control" v-model="model.quest.givePack.packs_quantity" type="number">
                        </div>
                      </div>
                      <div v-if="model.quest.reward === 2">
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Card Tier: select tier of card.">Other Reward</label>
                         <select class="form-select" v-model="model.quest.othersReward.others" v-on:change="othersSelected">
                              <option v-for="(value, key) in model.othersReward" v-bind:value="key">
                                {{ value.name }}
                              </option>
                          </select>
                      </div>
                      <div v-if="model.quest.othersReward.others === 2">
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: amount of barks to be rewarded.">Barks Value</label>
                        <input class="form-control" v-model="model.quest.othersReward.barks" type="number">
                      </div>
                       <div v-if="model.quest.othersReward.others === 1">
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: amount of barks to be rewarded.">Select Random Card</label>
                          <select class="form-select" v-model="model.quest.othersReward.randomCard" v-on:change="randomSelected">
                              <option v-for="(value, key) in model.randomcard" v-bind:value="key">
                                {{ value.name }}
                              </option>
                          </select>
                          <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: amount of barks to be rewarded.">Random Card Amount</label>
                          <input class="form-control" v-model="model.quest.othersReward.random_amount" type="number">
                      </div>
                    </div>
              
                    <button class="top-margin" data-button="submit" v-on:click="save()">Save</button>
                  </div>
                </div>
                </div>
              </div>

                 <div class="row">
                  <div class="col-12">
                    <div class="row columns">
                      <div class="col-2">
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: Medal name.">Quest Name</label>
                      </div>
                      <div class="col-2">
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: Detailed description of how the medal works.">Rules</label>
                      </div>
                      <div class="col-2">
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Price: price.">Start Date/Time</label>
                      </div>
                      <div class="col-2">
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Prefix: prefix.">Level Required</label>
                      </div>
                      <div class="col-2">
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Cooldown: Cooldown.">Mode</label>
                      </div>
                      <div class="col-2 edit">
                        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Edit: Click the row to edit the specific record.">Edit</label>
                      </div>
                    </div>
                    <div>
                      <div class="row data no-hover" v-for="(quest, index) in model.quests" :key="index" @click="toggleDetails(index)">
                        <div class="col-2">
                          {{ quest.name }}
                        </div>
                        <div class="col-2">
                          <label data-bs-toggle="tooltip" data-bs-placement="bottom" :title=" quest.description ">{{ quest.description }}</label>
                        </div>
                        <div class="col-2">
                          {{ formattedDate(quest.date) }} {{ quest.time }}
                        </div>
                        <div class="col-2">
                          {{ quest.level }}
                        </div>
                        <div class="col-2">
                          {{ quest.selectedMode }}
                        </div>
                        <div class="col-2 edit"  v-on:click="edit(quest.id)">
                          <i class="bi-pencil"></i> 
                        </div>
                    
                        <div class="col-12 no-hover" :class="model.expandedRow === index ? '' : 'expandable-row'">
                            <h3>Cards</h3>
                            <center>
                              <div class="col">
                                <div class="row columns">
                                  <div class="col-6">
                                    <label data-bs-toggle="tooltip" data-bs-placement="bottom">Cards</label>
                                  </div>
                                  <div class="col-6">
                                    <label data-bs-toggle="tooltip" data-bs-placement="bottom">Tier</label>
                                  </div>
                                </div>

                                <div class="row data" v-for="card in quest.cards">
                                  <div class="col-6">
                                  {{card.name}}
                                  </div>
                                  <div class="col-6">
                                  {{card.tier}}
                                  </div>
                                </div>

                              </div>
                            </center>
                            <div v-if="quest.packs">
                              <h3>Give Pack</h3>
                              <center>
                              <div class="col">
                                  <div class="row columns">
                                    <div class="col-6">
                                      <label data-bs-toggle="tooltip" data-bs-placement="bottom">Pack Name</label>
                                    </div>
                                    <div class="col-6">
                                      <label data-bs-toggle="tooltip" data-bs-placement="bottom">Quanity</label>
                                    </div>
                                  </div>

                                  <div class="row data">
                                    <div class="col-6">
                                      {{quest.packs.name}}
                                    </div>
                                    <div class="col-6">
                                      {{quest.packs.packs_quantity}}
                                    </div>
                                  </div>
                                </div>
                              </center>
                            </div>

                            <div v-if="quest.xp > 1">
                              <h3>Award XP</h3>
                              <center>
                              <div class="col">
                                  <div class="row columns">
                                    <div class="col-6">
                                      <label data-bs-toggle="tooltip" data-bs-placement="bottom">Wins Needed</label>
                                    </div>
                                    <div class="col-6">
                                      <label data-bs-toggle="tooltip" data-bs-placement="bottom">XP Amount</label>
                                    </div>
                                  </div>

                                  <div class="row data">
                                    <div class="col-6">
                                      {{quest.wins}}
                                    </div>
                                    <div class="col-6">
                                      {{quest.xp}}
                                    </div>
                                  </div>
                                </div>
                              </center>
                            </div>

                            <div v-if="quest.otherReward">
                              <h3>Other Rewards</h3>
                              <center>
                                <div class="col">
                                  <div class="row columns">
                                    <div class="col-3">
                                      <label data-bs-toggle="tooltip" data-bs-placement="bottom">Barks</label>
                                    </div>
                                    <div class="col-3">
                                      <label data-bs-toggle="tooltip" data-bs-placement="bottom">Planner</label>
                                    </div>
                                    <div class="col-3">
                                      <label data-bs-toggle="tooltip" data-bs-placement="bottom">Random Card</label>
                                    </div>
                                    <div class="col-3">
                                      <label data-bs-toggle="tooltip" data-bs-placement="bottom">Card Amount</label>
                                    </div>
                                    </div>

                                    <div class="row data no-hover">
                                      <div class="col-3">
                                        <i v-if="quest.otherReward.barks == 0" class="bi-x-lg"></i> 
                                        <div v-if="quest.otherReward.barks > 1">{{quest.otherReward.barks}}</div>
                                      </div>
                                      <div class="col-3">
                                        <i v-if="quest.otherReward.others == 0 " class="bi-check-lg"></i> 
                                        <i v-if="quest.otherReward.others >= 1 " class="bi-x-lg"></i> 
                                      </div>
                                      <div class="col-3">
                                        <i v-if="quest.otherReward.random_card == 0" class="bi-x-lg"></i>
                                        <div v-if="quest.otherReward.random_card >= 1">{{quest.otherReward.random_amount}}</div>
                                      </div>
                                      <div class="col-3">
                                        <i v-if="quest.otherReward.random_amount == 0" class="bi-x-lg"></i> 
                                        <div v-if="quest.otherReward.random_amount >= 1">{{quest.otherReward.random_amount}}</div>
                                      </div>
                                    </div>
                                    
                                </div>
                              </center>
                            </div>
                            
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

          </div>
         </div>
       </div>
     </div>
   </section>
 </div>
`,


  login: `
    <div data-component="login">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xs-12 col-md-6">
            <div class="card">
              <div class="row justify-content-md-center inputs">
                <div class="col-md-12">
                    <div>
                      <label>Email *</label>
                      <input v-model="model.email" type="email" @keyup.enter="login"/>
                    </div>
                    <div>
                      <label>Password *</label>
                      <input v-model="model.password" type="password" @keyup.enter="login"/>
                    </div>
                </div>
              </div>
              <div class="row submit">
                <div class="col-md-12">
                  <p v-if="model.error" class="error">Incorrect Email/Password Combination</p>
                  <button v-on:click="login" data-button="login">
                      <span v-if="!model.submitting">Log In</span>
                      <div v-if="model.submitting" class="show-spinner is-loading" data-loader="circle-side"></div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,

  stats: `
    <div class="row">
      <div class="col-4 col-md-2" v-for="stat in model.stats">
        <div class="card stats" v-bind:class="stat.type">
          <div class="icon">
            <i :class="stat.icon"></i>
          </div>
          <div class="stat">
            <h3 :title="stat.value">{{ stat.value }}</h3>
            <p :title="stat.type">{{ stat.type }}</p>
          </div>
        </div>
      </div>
    </div>
  `,

  cardLibrary: `
    <div data-component="cardssss-library">
      <div data-page="yours">
      
        <nav v-if="model.page.cards.length">
          <ul class="pagination justify-content-center" v-if="model.page.count > 1">
            <li class="page-item pagination-prev" v-bind:class="{ disabled: model.page.current == 1 }"><a class="page-link" v-on:click="previousPage">Previous</a></li>
            <li class="page-item" v-bind:class="{ active: index == model.page.current }" v-for="index in model.page.count" :key="index"><a class="page-link" v-on:click="setPage(index)">{{index}}</a></li>
            <li class="page-item pagination-next" v-bind:class="{ disabled: model.page.current == model.page.count }"><a class="page-link" v-on:click="nextPage">Next</a></li>
          </ul>
        </nav>

        <div>
          <playing-card v-bind:card="card" class="asd"  v-if="model.page.cards.length && card.active" v-for="card in model.page.cards"></playing-card>
          <h4 class="no-unlocks" v-if="!model.page.cards.length">No Cards Unlocked</h4>
        </div>

        <nav v-if="model.page.cards.length">
          <ul class="pagination justify-content-center" v-if="model.page.count > 1">
            <li class="page-item pagination-prev" v-bind:class="{ disabled: model.page.current == 1 }"><a class="page-link" v-on:click="previousPage">Previous</a></li>
            <li class="page-item" v-bind:class="{ active: index == model.page.current }" v-for="index in model.page.count" :key="index"><a class="page-link" v-on:click="setPage(index)">{{index}}</a></li>
            <li class="page-item pagination-next" v-bind:class="{ disabled: model.page.current == model.page.count }"><a class="page-link" v-on:click="nextPage">Next</a></li>
          </ul>
        </nav>
      </div>

      <div data-page="normal">
        <div>
          <playing-card v-bind:card="card" v-for="card in model.cards.normal"></playing-card>
        </div>
      </div>

      <div data-page="legendary">
        <div>
          <playing-card v-bind:card="card" v-for="card in model.cards.legendary"></playing-card>
        </div>
      </div>

      <div data-page="ultras">
        <div>
          <playing-card v-bind:card="card" v-for="card in model.cards.ultra"></playing-card>
        </div>
      </div>

      <div data-page="ultimates">
        <div>
          <playing-card v-bind:card="card" v-for="card in model.cards.ultimate"></playing-card>
        </div>
      </div>

      <div data-page="favorites">
        <div>
          <playing-card v-bind:card="card" v-for="card in model.cards.favorites"></playing-card>
        </div>
      </div>

      
      <div data-page="bone_cards">
        <div>
          <special-card v-bind:card="card" v-for="card in model.cards.special_bone"></playing-card>
        </div>
      </div>

      
      <div data-page="ascension_cards">
        <div>
          <special-card v-bind:card="card" v-for="card in model.cards.ascension"></playing-card>
        </div>
      </div>

      
      <div data-page="delta_cards">
        <div>
          <h1>delta cards</h1>
        </div>
      </div>

      <div class="view-card"><div></div></div>
    </div>
  `,

  viewerMedals: `
    <div data-component="viewer-medals">
      <div v-if="model.medals.length" v-for="medal in model.medals" class="medal" :data-id="medal.id">
        <div>
          <img :src="medal.image">
        </div>
        <p :title="medal.name">{{ medal.name }}</p>
        <p :title="medal.description" class="description">{{ medal.description }}</p>
        <p>Unlocked: {{ medal.count }}</p>
      </div>
      <h4 class="no-unlocks" v-if="!model.medals.length">No Achievements Unlocked</h4>

      <div class="view-element"><div></div></div>
    </div>
  `,

  viewerKeys: `
    <div data-component="viewer-keys">
      <div v-if="model.keys.length" v-for="key in model.keys" class="key" :data-id="key.id">
        <div>
          <img :src="key.image">
        </div>
        <p :title="key.name">{{ key.name }}</p>
        <p :title="key.description" class="description">{{ key.description }}</p>
        <p>Uses: {{ key.uses }}</p>
        <p class="bold">Key ID: #{{ key.keyNumber }}</p>
      </div>
      <h4 class="no-unlocks" v-if="!model.keys.length">No Keys Unlocked</h4>

      <div class="view-element"><div></div></div>
    </div>
  `,

  dogTags: `
    <div data-component="dog-tags">
      <div v-if="model.tags.length" class="dogtag-container">
        <div v-for="tag in model.tags" class="dogtag">
          <div class="information">  
            <p class="name" :title="tag.twitchDisplayName">{{ tag.twitchDisplayName }}</p>
          </div>
        </div>
      </div>
      <h4 class="no-unlocks" v-if="!model.tags.length">No Dog Tags</h4>
    </div>
  `,

  battleHelper: `
    <div data-component="battle-helper" v-bind:class="{ 'is-open': model.open }">
      <h4 v-on:click="open()">Battle Helper <button v-bind:class="{ 'is-open': model.open }"><i class="bi-arrow-down-square"></i></button></h4>
      <p>1. Choose the battle command type.</p>
      <p>2. Enter the Twitch display name of the users you want to battle.</p>
      <!--<p>3. Ctrl+click or press and hold on the cards you would like to use in the battle. Select at least <strong>{{model.counts.min}}</strong> cards to battle and a max of <strong>{{model.counts.max}}</strong>.</p>-->
      <p>3. Select a team, Ctrl+click or press and hold on the cards you would like to use in the battle. Select <strong>{{model.counts.min}}</strong> cards to battle with.</p>
      <div class="count">
        <label data-bs-toggle="tooltip" data-bs-placement="bottom">Cards Selected: {{ model.battle.count }}</label>
      </div>
      <div>
        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Command Type: Are you challenging a user or accepting a challenge?">Command Type <i class="bi-info-circle"></i></label>
        <select class="form-select" v-model="model.battle.action" @change="generateCommand">
          <option value="challenge">Challenge</option>
          <option value="accept">Accept</option>
        </select>
      </div>
      <div>
        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Twitch Display Name: Enter the users display name you would like to challenge.">Twitch Display Name <i class="bi-info-circle"></i></label>
        <input class="form-control search" v-model="model.battle.displayName" v-on:keyup="generateCommand()" type="text">
      </div>
      <div>
        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Your Teams: Select one of your team of cards?">Your Teams <i class="bi-info-circle"></i></label>
        <select class="form-select" v-model="model.battle.team" v-on:change="selectTeam">
          <option value="">Select Team</option>
          <option v-for="team in model.battle.teams" :value="team">{{ team.name }}</option>
        </select>
      </div>
      <div class="command" v-bind:class="{ enabled: model.battle.enabled }">
        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Display Name: Enter the users display name you would like to challenge.">Your Command</label>
        <textarea id="command" readonly class="form-control">{{ model.battle.command }}</textarea>
      </div>
      <button type="button" data-button="copy" v-on:click="copyCommand()" v-bind:class="{ 'is-disabled': !model.battle.enabled }"><i class="bi-clipboard-plus"></i> Copy</button>
      <p class="info">Copy and paste this command into SGTWoofy's stream chat.</p>

      <div class="teams">
        <p>4. Save this team to reuse the group of cards again.</p>
        <div v-bind:class="{ 'is-disabled': model.battle.cards.length != 4 }">
          <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Team Name: Set a unique name for this team of cards.">Team Name <i class="bi-info-circle"></i></label>
          <input class="form-control" v-model="model.battle.teamName" v-on:keyup="cleanName" type="text">
        </div>
        <button type="button" data-button="save" v-on:click="saveTeam()" v-bind:class="{ 'is-disabled': !model.battle.validName }"><i class="bi-save2"></i> Save Team</button>
        <button type="button" data-button="delete" v-on:click="deleteTeam()" v-bind:class="{ 'is-disabled': !model.battle.validName }"><i class="bi-trash"></i> Delete Team</button>
        <br>
       
        <p class="info">You update the name or cards of any team by selecting it and saving your changes.</p>
      </div>
    </div>
  `,

  themeSwitch: `
    <div data-component="theme-switch">
      <div class="row">
        <div class="col-7 col-lg-4">
          <h4>Theme</h4>
        </div>
        <div class="col-2 col-lg-3">
          Light
        </div>
        <div class="col-1 col-lg-2">
          <div class="form-check form-switch">
            <input v-model="model.theme" type="checkbox" class="form-check-input" @change="save()">
          </div>
        </div>
        <div class="col-2 col-lg-3">
          Dark
        </div>
      </div>
    </div>
  `,

hqBot: `
  <div data-component="hq-bot">
      <section>
        <div class="col-12">
          <div class="card">
            <div class="header">
              <h4>AI Bot</h4>
            </div>

            <div class="row">
              <div class="col-12">
                <div class="row">
                  <div class="grid-container" v-if="model.cards1.length === 0">
                    <div class="grid-item standard"v-bind:class="model.standard ? 'show' : 'is-disabled'">
                      <div class="row">
                        <div>
                        <h4>Standard</h4>
                        </div>
                        <button @click="standardStartBattle" class="center-button">
                          {{ model.botMode == 'standard' ? 'Selected' : 'Select' }}
                        </button>
                      </div>
                    </div>

                    <div class="grid-item ultra" v-bind:class="model.ultra ? 'show' : 'is-disabled'" >
                      <div class="row">
                        <div>
                          <h4>Ultra</h4>
                        </div>
                  
                        <button @click="ultraStartBattle($event)" class="center-button">
                           {{ model.botMode == 'ultra' ? 'Selected' : 'Select' }}
                        </button>
                      </div>
                    </div>

                    <div class="grid-item legendary" v-bind:class="model.legendary ? 'show' : 'is-disabled'" >
                      <div class="row">
                        <div>
                          <h4>Legendary</h4>
                        </div>
                        <button @click="selectLegendary()" class="center-button">
                            {{ model.botMode == 'legendary' ? 'Selected' : 'Select' }}
                        </button>
                      <div>
                    </div>


                  </div>
                </div>
              </div>
              <div v-else>
                <div data-component="battle-arena" class="always-display">
                <!--<button v-on:click="stop()">stop battle</button>-->
                  <div class="content">
                    <div class="row cards" v-bind:class="{ show: model.show.cards }">
                      <div class="col-4 cards-1">
                        <playing-card v-bind:card="card" class="bot-cards" v-bind:show="'true'" v-for="card in model.cards1"></playing-card>
                      </div>
                      <div class="col-4">
                        <div class="log" v-bind:class="{ show: model.show.logs }">
                          <p v-for="log in model.logs" :title="log">{{ log }}</p>
                        </div>
                      </div>
                      <div class="col-4 cards-2">
                        <playing-card v-bind:card="card" class="bot-cards" v-bind:show="'true'" v-for="card in model.cards2"></playing-card>
                      </div>
                    </div>
                  </div>
                  <div class="winner" v-bind:class="{ show: model.show.winner }">
                    
                    <div></div>
                  </div>
                </div>  
              </>
            </div>

           
            
          </div>
        </div>
      </section>
  </div>

  `,

hqStore  : `
  <div data-component="hq-store">
      <section>
        <div class="row">
          <div class="col-12">
            <div class="card">

              <div class="header">
                <h4>Store</h4>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="row columns">
                    <div class="col-4 top"  v-if="store.tier < 2" :id="store.id" v-for="store in model.stores">
                      <div class="user">
                        <div class="info">
                          <p class="name">{{ store.name }}</p>
                          <p>Remaining Time: {{ formatTime(store.cooldown) }}</p>
                         
                          <small><p>{{store.description}}</p></small>
                        </div>
                        <button type="button"  @click="buy(store)" class="secondary w-full" :class="{activated: store.usertier >= store.tier || store.tier > 1 } ">
                              <div v-if="store.usertier > store.tier">ACTIVE</div>
                              <div v-else-if="store.tier > 1">INACTIVE</div>
                              <div v-else>
                                Buy  <span class="bg-[#fddd10] text-black text-lg font-bold me-2 px-2.5 py-0.5 rounded-full dark:text-white"><i class="bi bi-currency-dollar"></i>{{store.price}}</span>
                              </div>
                        </button>
                      </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
  </div>
  `,

hqOpenPack: `
  <div data-component="hq-open-pack">
          <div class="col-12">
            <div class="card">

              <div class="header">
                <h4>Open Pack Queue</h4>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <HQunlockQueue></HQunlockQueue>
                  </div>
                </div>
              </div>

            </div>
          </div>
  </div>
`,


hqCardManagement: `
<div data-component="card-management">
     <div class="tabs">
            <ul class="tab-list flex justify-center">
                <li class="tab-item" v-bind:class="{ active: model.tab == 'tab1'}" @click="showTab('tab1')">Team Stats</li>
                <li class="tab-item" v-bind:class="{ active: model.tab == 'tab2'}" @click="showTab('tab2')">Inventory</li>
            </ul>
      </div>

      <!-- Tab Content -->
      <div class="tab-content">
          <div id="tab1" class="tab" v-bind:class="{ active: model.tab == 'tab1'}">
                <div class="flex flex-row w-full justify-center sticky top-24 z-50">
                    <div class="bg-[#272727] p-3">Attack: <span class="text-red-600">{{model.stats.total_atk}}</span></div>
                    <div class="bg-[#272727] p-3">Defense: <span class="text-red-600">{{model.stats.total_def}}</span></div>
                    <div class="bg-[#272727] p-3">Accuracy: <span class="text-red-600">{{model.stats.total_acc}}</span></div>
                    <div class="bg-[#272727] p-3">Speed: <span class="text-red-600">{{model.stats.total_spd}}</span></div>
                    <div class="bg-[#272727] p-3">Hp: <span class="text-red-600">{{model.stats.total_hp}}</span></div>
                  </div>
                <div class="drop-area content-center" @dragover.prevent="onDragOver" @drop="onDrop">  
                  <div>
                      <h1 class="text-center remove_me"> drag cards here</h1>
                      <playing-card v-bind:card="card" class="custom-class hq-select" v-for="card in model.battle.cards"></playing-card>
                  </div>
                </div>
            
          </div>
          <div id="tab2" class="tab" v-bind:class="{ active: model.tab == 'tab2'}">
          
                   <div class="" v-if="model.chamber.open"> 
                      <div class="flex flex-row w-full justify-center sticky top-24 z-50">
                        <div class="bg-[#272727] p-3">Ascension: <span class="text-red-600">{{model.chamber.total_ascension}}</span></div>
                        <div class="bg-[#272727] p-3">{{model.chamber.tierName !== null ? model.chamber.tierName : 'Prime'}} Card: <span class="text-red-600">{{model.chamber.count}}</span></div>
                      </div>
                      <div class="drop-area" @dragover.prevent="chamberDragOver" @drop="chamberDrop">
                        <div class="mt-5">
                            <special-card v-bind:card="card" class="custom-class ascension-card" v-for="card in model.chamber.ascensionCard"></special-card>
                            <playing-card v-bind:card="card" class="custom-class chamber-select" v-for="card in model.chamber.cards"></playing-card>
                            <div class="playing-card-box ascension playing-card-container " v-for="index in model.chamber.total_ascension"></div>
                            <div class="playing-card-box playing-card-container" v-for="index in model.chamber.count"> </div>
                        </div>  
                      </div>
                  </div>
                  <div v-else>
                    <div class="drop-area">
                     <div class="grid-container">
                       <user-inventory v-bind:inventory="inventory" v-for="inventory in model.inventory"></user-inventory>
                        <div class="dump dumps" id="dump2"  @dragover.prevent @drop="dumpCard($event)" >
                            <button class="close-button" @click="closeDump">X</button>
                            <h2>Dump Cards</h2>
                             <component
                                v-for="card in model.dump.dumpCards"
                                :key="card.id"
                                :is="card.tier >= 4 ? 'special-card' : 'playing-card'"
                                :card="card"
                                :show="'true'"
                                class="custom-class dump-remove"
                              ></component>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
          </div>
            <div class="forge-card">
                <special-card v-bind:card="model.bone_card" class="blind_card"></special-card>
            </div>
            <div class="ascension-chamber">
                <playing-card v-bind:card="model.ascension_chamber_card" class="asc"></playing-card>
            </div>
     
      </div>
      </div>

      
</div>
`,

teamDrawer: `
  <div data-component="team-drawer">
    <div class="drawer-overlay" v-if="isOpen" @click.self="closeDrawer">
      <div class="drawer is-open" ref="drawer">
        <div class="drawer-content">
         <div class="p-4">
            <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Your Teams: Select one of your team of cards?">Your Teams <i class="bi-info-circle"></i></label>
            <select class="form-select mb-6" v-model="model.battle.team" v-on:change="selectTeam">
              <option value="">Select Team</option>
              <option v-for="team in model.battle.teams" :value="team">{{ team.name }}</option>
            </select>
          </div>
          <div class="p-4">
            <p class="font-bold">Save this team to reuse the group of cards again.</p>
            <div v-bind:class="{ 'is-disabled': !model.battle.cards.length }">
              <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Team Name: Set a unique name for this team of cards.">Team Name <i class="bi-info-circle"></i></label><br>
              <input class="form-control" v-model="model.battle.teamName" v-on:keyup="cleanName"  type="text">
            </div>
          </div>
            <div class="p-4">
                <button type="button" data-button="save" v-on:click="saveTeam()" v-bind:class="{ 'is-disabled': !model.battle.validName }" class=" w-full"><i class="bi-save2"></i> Save</button>
                <button type="button" class="delete_team w-full" v-on:click="deleteTeam()" v-bind:class="{ 'is-disabled': !model.battle.validName }"><i class="bi-trash"></i> Delete</button>
                <br>
                <br>
                <div v-if="model.botLoaded">
                   <button type="button" v-on:click="practiceBot()" class="secondary w-full"v-bind:class="{ 'is-disabled': !model.battle.cards.length }"">
                    Start Battle
                   </button>
                </div>
                <div v-else>
                 <button type="button" v-on:click="practiceBot()" class="play-bot w-full"v-bind:class="{ 'is-disabled': !model.battle.cards.length }"">
                  <i class="bi-check-fill"></i>
                  Practice with Bot
                </button>
                </div>
               
            </div>

          <div class="p-4">
            <p class="info bg-[#fddd10] rounded text-black font-bold">You update the name or cards of any team by selecting it and saving your changes.</p>
          </div>

        </div>
       </div>

  </div>

`,

deepStats  : `
  <div data-component="deepstats">
     <section>
        <div class="row">
          <div class="col-12">
            <div class="card">
            
              <div class="row">
                <div class="col-12">
                  <div class="row columns">

                   <div class="col-4 top" >
                      <div class="user">
                          <h1>Best Team</h1>
                          <div class="title">
                            <p>{{model.bestTeam.name}}</p>
                          </div>
                    
                        <div class="top-stats">
                          <div>    
                          <div class="top-team">
                            <playing-card v-bind:card="card" v-bind:show="'true'" v-for="card in model.bestTeam.highestTeamCards"></playing-card>
                         </div>
                        </div>
                          <div class="second-column">
                             <div class="table">
                                <div class="table-row">
                                    <div class="table-cell">Win:</div>
                                    <div class="table-cell">{{model.bestTeam.highestTeamWinCount}} </div>
                                </div>
                                <div class="table-row">
                                    <div class="table-cell">Loss:</div>
                                    <div class="table-cell">{{model.bestTeam.highestTeamLoseCount}}</div>
                                </div>
                            </div>
                   
                          </div>
                        </div>
                      </div>
                    </div>
                 
                     <div class="col-4 top" >
                      <div class="user">
                        <h1>Worst Team</h1>
                        <div class="title">
                          <p>{{ model.worstTeam.lowestTeamWin}}</p>
                        </div>
                        <div class="info">
                          <div class="top-team">
                                <playing-card v-bind:card="card" v-bind:show="'true'" v-for="card in model.worstTeam.lowestTeamCards"></playing-card>
                          </div>
                           <div class="top-stats">
                          <div></div>
                          <div class="second-column">
                             <div class="table">
                                <div class="table-row">
                                    <div class="table-cell">Win:</div>
                                    <div class="table-cell">{{model.worstTeam.lowestTeamWinCount}} </div>
                                </div>
                                <div class="table-row">
                                    <div class="table-cell">Loss:</div>
                                    <div class="table-cell">{{model.worstTeam.lowestTeamLoseCount}}</div>
                                </div>
                            </div>
                          </div>
                        </div>
                        </div>
                      </div>
                    </div>

                   <div class="col-4 top" >
                      <div class="user">
                        <h1>Top Performing Card</h1>
                        <div class="title">
                          <p>{{ model.topCard.highestCardWin[0].name }}</p>
                        </div>
                        <div class="info">
                          <div class="top-card">
                                <playing-card v-bind:card="card" v-bind:show="'true'" v-for="card in model.topCard.highestCardWin"></playing-card>
                          </div>
                           <div class="top-stats">
                          <div></div>
                          <div class="second-column">
                             <div class="table">
                                <div class="table-row">
                                    <div class="table-cell">Win:</div>
                                    <div class="table-cell">{{model.topCard.highestCardWinCount}} </div>
                                </div>
                                <div class="table-row">
                                    <div class="table-cell">Loss:</div>
                                    <div class="table-cell">{{model.topCard.highestCardLoseCount}}</div>
                                </div>
                            </div>
                          </div>
                        </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-4 top" >
                      <div class="user">
                        <h1>Worst Performing Card</h1>
                        <div class="title">
                          <p>{{ model.lowestCard.lowestCardWin[0].name }}</p>
                        </div>
                        <div class="info">
                          <div class="top-card">
                                <playing-card v-bind:card="card" v-bind:show="'true'" v-for="card in model.lowestCard.lowestCardWin"></playing-card>
                          </div>
                           <div class="top-stats">
                          <div></div>
                          <div class="second-column">
                             <div class="table">
                              <div class="table-row">
                                    <div class="table-cell">Loss:</div>
                                    <div class="table-cell">{{model.lowestCard.lowestCardLoseCount}}</div>
                                </div>
                                <div class="table-row">
                                    <div class="table-cell">Win:</div>
                                    <div class="table-cell">{{model.lowestCard.lowestCardWinCount}} </div>
                                </div>
                               
                            </div>
                          </div>
                        </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-4 top" >
                      <div class="user">
                        <h1>Most Wins Against Player</h1>
                        <div class="title">
                          <p>{{ model.mostWinOnPlayer.highestOnOpponent }}</p>
                        </div>
                        <div class="info">
                           <div class="top-stats">
                          <div class="second-column">
                            <img :src="model.mostWinOnPlayer.profile" />
                          </div>
                          <div class="second-column">
                             <div class="table">
                                <div class="table-row">
                                    <div class="table-cell">Win:</div>
                                    <div class="table-cell">{{model.mostWinOnPlayer.highestWinOnOpponentCount}} </div>
                                </div>
                                <div class="table-row">
                                    <div class="table-cell">Loss:</div>
                                    <div class="table-cell">{{model.mostWinOnPlayer.lossOnOpponentCount}}</div>
                                </div>
                            </div>
                          </div>
                        </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-4 top" >
                      <div class="user">
                        <h1>Most Loss Against Player</h1>
                        <div class="title">
                          <p>{{ model.mostLossOnPlayer.lowestWinOpponent }}</p>
                        </div>
                        <div class="info">
                           <div class="top-stats">
                          <div class="second-column">
                            <img :src="model.mostLossOnPlayer.profile" />
                          </div>
                          <div class="second-column">
                             <div class="table">
                                <div class="table-row">
                                    <div class="table-cell">Loss:</div>
                                    <div class="table-cell">{{model.mostLossOnPlayer.lowestLossOnOpponentCount}} </div>
                                </div>
                                <div class="table-row">
                                    <div class="table-cell">Win:</div>
                                    <div class="table-cell">{{model.mostLossOnPlayer.lowestWinOnOpponentCount}}</div>
                                </div>
                            </div>
                          </div>
                        </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>

                  <div class="tab-container">
                      <div class="tabd title" v-bind:class="{ active: model.tab == 'tab1'}"  @click="showTab('tab1')">History against Player</div>
                      <div class="tabd title" v-bind:class="{ active: model.tab == 'tab2'}" @click="showTab('tab2')">Battle History</div>
                  </div>
                  <div class="tab-content">
                      <div id="stats-tab" class="stats-content" v-bind:class="{ active: model.tab == 'tab1'}">

                        <div class="row">
                            <h1>record against player history</h1> </ br>
                            <div class="col-12">
                              <div class="row columns headers">
                                <div class="col-4 col-md-3">
                                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Player 1</label>
                                </div>
                                <div class="col-4 col-md-3">
                                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Player 2</label>
                                </div>
                                <div class="col-4 col-md-3">
                                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Wins</label>
                                </div>
                                <div class="col-4 col-md-3">
                                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Losses</label>
                                </div>
                              </div>
                              <div class="table">
                                <div class="row data" v-for="user in model.opponentHistory">
                                    <div class="col-3 col-md-3 info">
                                      <img :src="user.player1_image" class="player_history_image"/>
                                      <p :title="user.user1">{{ user.user1 }}</p>
                                    </div>
                                    <div class="col-3 info">
                                        <img :src="user.player2_image" class="player_history_image"/>
                                        <p :title="user.opponent">{{ user.opponent }}</p>
                                    </div>
                                    <div class="col-3 col-md-3">
                                      <p>{{ user.opponent_wins }}</p>
                                    </div>
                                    <div class="col-3s col-md-3">
                                      <p>{{ user.opponent_loss }}</p>
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                      
                      </div>
                      <div id="hist-tab" class="stats-content" v-bind:class="{ active: model.tab == 'tab2'}">

                        <div class="row">
                            <h1>Battle History</h1> </ br>
                            <div class="col-12">
                              <div class="row columns headers">
                                <div class="col-4 col-md-3">
                                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Opponent</label>
                                </div>
                                <div class="col-4 col-md-3">
                                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Cards</label>
                                </div>
                                <div class="col-4 col-md-3">
                                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Battle Status</label>
                                </div>
                                <div class="col-4 col-md-3">
                                  <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Date</label>
                                </div>
                              </div>
                              <div class="table">
                                <div class="row data" v-for="user in model.playerHistory">
                                    <div class="col-3 col-md-3 info">
                                      <img :src="user.profile" class="player_history_image"/>
                                      <p :title="user.user1">{{ user.opponent }}</p>
                                    </div>
                                    <div class="col-3 info">
                                        <p :title="user.Cards">{{ user.Cards }}</p>
                                    </div>
                                    <div class="col-3 col-md-3">
                                      <p :class="user.BattleStatus === 'Winner' ? 'win' : 'loss' ">{{ user.BattleStatus }}</p>
                                    </div>
                                    <div class="col-3s col-md-3">
                                      <p>{{ user.dateUpdated }}</p>
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                      </div>
                  </div>
                

                  </div>

                </div>

              </div>

            </div>
          </div>
        </div>
        <div data-component="view-medal">
          <div class="view-element"><div></div></div>
        </div>
      </section>
  </div>
`,

confirmModal : `
    <div data-component="confirm-modal">
          <div class="modal" >
            <div class="modal-content">
                <div v-if="model.card">
                  <h1>{{model.message}}</h1>
                </div>
             
                <button type="button" data-button="save" v-on:click="confirm()">Yes</button>
                <button type="button" class="delete_team" v-on:click="cancel()">Cancel</button>
            </div>
          </div>
    </div>
`


};
